desktop_view = 'large--one-quarter'

screen_small = 600
screen_large = 1050

header_height = $('#site-header').outerHeight() 
header_height_mob = $('#topbar-mobile').outerHeight()
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator': 
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  } 

  return formatString.replace(placeholderRegex, value);
};


//SET COOKIES FUNCTION

/*
function setCookie(cname,cvalue,exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires=" + d.toGMTString();
	
	if (window.location.href.indexOf('afendsdev.myshopify.com') > -1) {
		document.cookie = cname+"="+cvalue+"; "+expires + "; domain=.afendsdev.myshopify.com; path=/";
	} else {
		document.cookie = cname+"="+cvalue+"; "+expires + "; domain=.afends.com; path=/";		
	}
}*/

function setCookie(cookieName,cookieValue,daysToExpire){
	var date = new Date();
	date.setTime(date.getTime()+(daysToExpire*24*60*60*1000)); 
	document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString()+"; path=/";
	//document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString() + "; domain=.afends.com";
}

 
//GET COOKIES FUNCTION 
/*
function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i=0; i<ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1);
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";  
}*/

function getCookie(cookieName)
{
	var name = cookieName + "=";
	var allCookieArray = document.cookie.split(';');
	for(var i=0; i<allCookieArray.length; i++){
		var temp = allCookieArray[i].trim();
		if (temp.indexOf(name)==0)
			return temp.substring(name.length,temp.length);
	}
	return "";
}

const queryWindowParamsString = window.location.search.substr(1);
const queryUrlParams = queryWindowParamsString.split('&').reduce((accumulator, singleQueryParam) => {
	const [key, value] = singleQueryParam.split('=');
	accumulator[key] = decodeURIComponent(value);
	return accumulator;
}, {});
//let region = getCookie('geo_location_v3');

//Get the URL paramter so we can grab the currency during a redirect between AU/US
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('?'),
        sParameterName,
        i;  

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    } 
};

function eventTracking(){
	/* HEADER ACTIONS */
	$('.actions .user').click(function(){
		ga('send', 'event', { 
			eventCategory: 'Actions',
			eventAction: 'Icon Click',
			eventLabel: 'User Icon'
		}); 
	});
	
	$('.actions .search').click(function(){
		ga('send', 'event', {
			eventCategory: 'Actions',
			eventAction: 'Icon Click',
			eventLabel: 'Search Icon'
		}); 
	}); 
	
	$('.actions .header-cart, .cart-dropdown-checkout').click(function(){
		ga('send', 'event', {
			eventCategory: 'Actions',
			eventAction: 'Icon Click',
			eventLabel: 'Cart Icon'
		}); 
	}); 
	
	$('#scroll-top button').click(function(){
		ga('send', 'event', {
			eventCategory: 'Actions',
			eventAction: 'Icon Click',
			eventLabel: 'Scroll Top'
		}); 
	});
	
	$('.afterpay.cart').click(function(){
		ga('send', 'event', {
			eventCategory: 'Cart',
			eventAction: 'Afterpay',
			eventLabel: 'Link Click'
		}); 
	});	
}

function accordions(){
	$('.accordion').not('.loaded').each(function(index) {
		currect_accordian = $(this)
		content = $(this).html().split('<h4>');
	
		$(this).empty();
		$.each(content, function(i, value) {
			//console.log('-'+value+'-')
			if (value.length > 2) {
				value = value.replace('</h4>','</button><div class="panel">');
				$(currect_accordian).append('<button type="button">'+value+'</div>');
			}
		});
	
	});


	var acc = $(".accordion button");
	var i;

	for (i = 0; i < acc.length; i++) {
		acc[i].addEventListener("click", function() {
			var active_acc = $('.accordion .active')
			
			/*
			active_acc.classList.toggle("active");
			active_panel = active_acc.nextElementSibling;
			active_panel.style.maxHeight = null;*/
			
			active_acc.removeClass('active')
			active_acc.next('.panel').css({'max-height' : ''})
			
			this.classList.toggle("active");
			var panel = this.nextElementSibling;
			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
			} else {
				panel.style.maxHeight = panel.scrollHeight + 30 + "px";
			} 
		});
	}
	
	
	var accordian = document.getElementsByClassName("accordion-btn");
	var i;

	for (i = 0; i < accordian.length; i++) {
		accordian[i].addEventListener("click", function() {
			/* Toggle between adding and removing the "active" class,
			to highlight the button that controls the panel */
			this.classList.toggle("active");

			/* Toggle between hiding and showing the active panel */
			var panel = this.nextElementSibling;
			if (panel.style.display === "block") {
				panel.style.display = "none";
			} else {
				panel.style.display = "block";
			}
		});
	}
}

function loadBackgroundImages() {
	$('.parallax').each(function() {
		windowsize = $(window).width();
		
		if (windowsize < 600) {
			$(this).css('background-image', 'url(' + $(this).data('bgs') + ')'); 
		}
		if ((windowsize >= 601) && (windowsize <= 1400)) {
			$(this).css('background-image', 'url(' + $(this).data('bgm') + ')'); 
		}
		if (windowsize >= 1401) {
			$(this).css('background-image', 'url(' + $(this).data('bgl') + ')'); 
		}
	});
} 

function lazyloadVideos() {	
	var lazyVideos = [].slice.call(document.querySelectorAll('.lazy-video'));

	if ("IntersectionObserver" in window) {
		var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(video) {
				if (video.isIntersecting) {
					for (var source in video.target.children) {
						var videoSource = video.target.children[source];
						if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
							videoSource.src = videoSource.dataset.src;
						}
					}
					video.target.load();
					video.target.classList.add("lazy-video");
					lazyVideoObserver.unobserve(video.target);
				}
			});
		});

		lazyVideos.forEach(function(lazyVideo) {
			lazyVideoObserver.observe(lazyVideo);
		});
	}
}

if(navigator.userAgent.indexOf("Chrome") != -1 ) {
	//console.log('chrome yo')
}

/**
 * If browser back button was used, flush cache
 * This ensures that user will always see an accurate, up-to-date view based on their state
 * https://stackoverflow.com/questions/8788802/prevent-safari-loading-from-cache-when-back-button-is-clicked

Fixes issues with some loading="lazy" images not loading when clicking back button on iOS safari May 2022 - might want to review from time to time to see if this is still required

 */

var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

(function () {
	window.onpageshow = function(event) {
		if (event.persisted && iOS ) {
            $('.product-image img').attr('src', function (i, val) { return val; }); // reload only iframes
			/*
			const lazyImages = document.querySelectorAll('img[loading="lazy"]');
			// For each image, check if it has been loaded
			lazyImages.forEach(image => {
				// If the image has not been loaded, load it
				if (!image.complete) {
					image.src = image.getAttribute('data-src');
				}
			});*/
			
			//window.location.reload();
		} 
	};
})();


var pathname = window.location.pathname + window.location.search; // Returns path only
			  
function checkCookie() { 
	//Check store selector cookie
	
	/*
	var selected_store = getCookie("selected-store");
	
	if (selected_store != "") {	
		if (store_location != selected_store) {
			$('.store-list').removeClass('active');
			$('#store-helper').fadeIn();
		}
	} else {
		setCookie("selected-store", store_location, 1);
		
		//Show Info popup	
		$('#store-select-popup').fadeIn();	
	}*/
}


if ( (getCookie('cookies-accepted-v2') != 'true') && (!Shopify.designMode) )  {
	setTimeout(function() {
		if (tapcart != true) {
			$('#cookies-popup').fadeIn();
		}
	}, 7000);
} else {
	//Accepted cookies variable for Rakuten
	window.__rmcp2 = [1,2,3,4,5,6,7,8,9,10];
	
	if (getCookie('app-popup') != 'true') {		
		//Show app popup		
		if ( /Android|iPhone|iPad/i.test(navigator.userAgent) ) {			
			$app_btn = $('#app-popup .webbanner-button')
			us_ios = 'https://apps.apple.com/us/app/afends-us/id1569221909'
			us_android = 'https://play.google.com/store/apps/details?id=co.tapcart.app.id_t3rMhbB5Q4'
			au_ios = 'https://apps.apple.com/us/app/afends-au/id1568128486'
			au_android = 'https://play.google.com/store/apps/details?id=co.tapcart.app.id_uqxHVKB78H'
			
			if ( store_location == 'us') {
				if ( /Android/i.test(navigator.userAgent) ) {
					$app_btn.attr('href',us_android)
				} else {
					$app_btn.attr('href',us_ios)					
				}
			} else {
				if ( /Android/i.test(navigator.userAgent) ) {
					$app_btn.attr('href',au_android)
				} else {
					$app_btn.attr('href',au_ios)					
				}
			}
			$('#app-popup').fadeIn()
		} else {
			//show newsletter
			if ( getCookie('newsletter-popup') != 'true' && newsletter_popup_enabled == true && !Shopify.designMode ) {
				setTimeout(function() {
					$('#newsletter-popup').fadeIn()
					setCookie('newsletter-popup', 'true', 7);
					ga('send', 'event', 'Marketing', 'Popup', 'Shown', { nonInteraction: true });
				}, 5000);
			}
		}  
	} else {
		//show newsletter
		if ( (getCookie('newsletter-popup') != 'true') && (newsletter_popup_enabled == true) && (!Shopify.designMode) ) {
			setTimeout(function() {
				$('#newsletter-popup').fadeIn()
				setCookie('newsletter-popup', 'true', 7);
				ga('send', 'event', 'Marketing', 'Popup', 'Shown', { nonInteraction: true });
			}, 5000);
		}
	}
}

$('#app-popup .webbanner-button').click(function() {
	setCookie('app-popup', 'true', 3000);
	$('#app-popup').fadeOut();
});

$('#app-popup .close-popup').click(function() {
	app_close_count = parseInt(getCookie('app-close-count'))	
	if ( isNaN (app_close_count) ) {
		app_close_count = 0
	}
	app_close_count = app_close_count + 1
	
	setCookie('app-close-count', app_close_count, 3000);
	if ( app_close_count < 3 ) {
		setCookie('app-popup', 'true', 2);
	} else {
		setCookie('app-popup', 'true', 3000);
	}
	
	$('#app-popup').fadeOut();
});

$('#accept-cookies').click(function(e) {
	setCookie('cookies-accepted-v2', 'true', 3000);
	$('#cookies-popup').fadeOut();
	//Accepted cookies variable for Rakuten
	window.__rmcp2 = [1,2,3,4,5,6,7,8,9,10];
});


function initCheckCookie(){
	var newsletter_popup_seen=getCookie("film_access");
	if (newsletter_popup_seen != "") {
		//console.log("Customer subscribed to view film");
	}
}
initCheckCookie();
	
sessionStorage.readyforpopup = 'ready';
if(sessionStorage.readyforpopup && sessionStorage.readyforpopup === 'ready'){
	//console.log('its ready');
	checkCookie('film_access');
}

//let cookie_currency = getCookie('currency');

let cart_currency = 'AUD';
if ( getCookie('cart_currency') == "") {
	if ( store_location == 'us' ) {
		cart_currency = 'USD'
	} else if ( store_location == 'eu' ) {
		cart_currency = 'EUR'
	}
} else {
	cart_currency = getCookie('cart_currency')	
}

const
	eu_currencies = 'EUR',
	au_currencies = 'AUD NZD SGD HKD',
	us_currencies = 'CAD USD JPS';

function currencyFormSubmit(event) {
	event.target.form.submit();
}

document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
	element.addEventListener('change', currencyFormSubmit);
});

function currencyMoney(){
	Shopify.formatMoney(variant.price)
}

function changeCurrency(new_currency){
	//delete currency cookie
	console.log('changing currency ' + region + ' ' +new_currency) 
	
	//Delete all currency cookies just to be safe
	document.cookie = "currency= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
	document.cookie = "cart_currency= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
	
	console.log( region )
	
	if (store_location == 'au') {
		if (au_currencies.indexOf(new_currency) === -1) {
			new_currency = 'AUD'
		}
	} else if (store_location == 'eu') {
		if (au_currencies.indexOf(new_currency) === -1) {
			new_currency = 'EUR'
		}
	} else if (store_location == 'us') { 
		if (us_currencies.indexOf(new_currency) === -1) {
			new_currency = 'USD'
		}
	}
		
	$('.shopify-currency-form option:contains('+ new_currency +')').prop('selected', true).trigger('change');
	$('.shopify-currency-form').submit();
}
 
var money = function(value){
	value = Shopify.formatMoney(value) + ' ' + cart_currency;
				
	if (cart_currency == 'JPY' ) {
		value = value.replace('.00','') 
	} else if (cart_currency == 'EUR' ) {
		value = value.replace('$','')
	}
	return value
}
  
var currency_param = queryUrlParams.currency;
if (typeof currency_param != 'undefined') {
	//alert( currency_param )
	
	if ( cart_currency != currency_param) { 
		//If currency cookie doesn't match cart currency cookie we need to change it
		changeCurrency(currency_param)
	}
}

/*
TEMP DISABLED
if ( cookie_currency != "") { 
	//console.log( cookie_currency +' / '+ currency );
	
	//If we have a currency cookie
	if ( cookie_currency != currency) { 
		//If currency cookie doesn't match cart currency cookie we need to change it
		changeCurrency(cookie_currency)
	}
}*/
var tapcart_param = queryUrlParams.tapcart;

tapcart = false
if(typeof tapcart_param != 'undefined') {
	tapcart = true
}

if (tapcart == true){
	$('#site-header, #topbar-mobile, #newsletter-popup, footer').hide()
}


var convert_size = function(product_title,value){
	if (product_title.indexOf('Womens') > -1) {
		if (store_location == 'us' || store_location == 'eu') {
			//Resize womens/unisex universal
			value = value.replace('36', 'aa').replace('28', 'bb').replace('26', 'cc').replace('6', 'XS').replace('8', 'S').replace('10', 'M').replace('12', 'L').replace('14', 'XL').replace('aa', '36').replace('bb', '28').replace('cc', '26');								
		}
		//Resize wommens bottoms
		if (store_location == 'us') {
			value = value.replace('24', '2').replace('26', '4').replace('28', '6').replace('30', '8').replace('32', '10');	
		}
		if (store_location == 'eu') {
			value = value.replace('24', '34').replace('26', '36').replace('28', '38').replace('30', '40').replace('32', '42');	
		}
	} else {
		//Mens Sizing
		if (store_location == 'eu') {
			value = value.replace('28', '38').replace('30', '40').replace('32', '42').replace('34', '44').replace('36', '46');	
		}
	}
	return value
}
if ( getCookie("a-b-test") != "") { } else {
	random = parseInt(Math.random() * 2)
	setCookie("a-b-test", random, 1);
}
 
if ( getCookie("a-b-test-reported") == "" && typeof ga !== "undefined"){
	setTimeout(function() {
		if (getCookie("a-b-test") == 0 ){
			ga('send', 'event', 'Test', 'A/B Split', 'Visitor - A', { nonInteraction: true });		
		} else {
			ga('send', 'event', 'Test', 'A/B Split', 'Visitor - B', { nonInteraction: true });
		}
		setCookie("a-b-test-reported", 'reported', 1);
	}, 1000);
} 

	
if (getCookie("a-b-test") == '1') {
	//$('#footer-signup-text').text('Sign up to receive $10 off your first order.')
	 
	/*
	$('a').each(function(index, link) {
		link_url = $(link).attr("href")
		
		if (link_url) {
			if (link_url.indexOf('/cart') > -1) {
				$(link).attr('href', '/checkout'); // Change this to .html()
			}
		}
	});*/
}

/*
if (custom_checkout == 'false') {
	setCookie("a-b-test", '9', 1);
} */
function account_panel(hash){
	$('.account-group').fadeOut(99).delay(100);
	$(hash).fadeIn();
	
	$('html, body').animate({
		scrollTop: $("#account-content").offset().top - 100
	}, 1000);
}

$('a.account-nav').click(function(e) {
    e.preventDefault();
	var hash = $(this).attr("href");
	account_panel(hash)
});  
 
$('#account-avatar').click(function() {
	$('.account-group').fadeOut(99).delay(100);
	$('#account_landing').fadeIn();
});

$('#create_customer .btn--full').click(function() {
	setCookie("created-account", 'yes', 1); 
});

if ( getCookie('created-account') == 'yes' && window.location.pathname == '/' )  {
	setCookie("created-account", "", 0.1);
	document.cookie = 'created-account' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT; domain=afends.com; path=/';
	document.cookie = 'created-account' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT; domain=.afends.com; path=/';
	window.location.replace("/pages/rewards");
}

$(document).ready(function() {	
	var hash = window.location.hash;			
	
	if ( $('.account-group').length != 0 ) {
		if (hash.length) {
			account_panel(hash)
		} else {
			var hash = '#account_landing';
			account_panel(hash); 
		}
	}
});



/* NAVIGATION */
var MobileMenu = function(){
	
	if ($(window).width() > screen_large) {
		$('#page-container').css('padding-top', header_height);
	} else {
		$('#page-container').css('padding-top', header_height_mob);		
	} 
	
	$("#mobile-menu .has-children .trigger").click(function(e){
		if ( $(this).is('.back-to-parent') ) {
			e.preventDefault();
			$(this).next("ul").slideUp(); 
			$(this).removeClass('back-to-parent') 
		} else {			
			e.preventDefault();
			
			closest_parent = $(this).closest('.parent')
			closest_child = $(this).closest('.child')
			closest_ul = $(this).closest('ul')
			navList = $(this).closest('.nav-list')
			
			closest_ul.find('.parent').not(closest_parent).find('ul').slideUp();
			closest_ul.find('.parent').not(closest_parent).find('a').removeClass('back-to-parent');
			
			closest_ul.find('.child').not(closest_child).find('ul').slideUp();
			closest_ul.find('.child').not(closest_child).find('a').removeClass('back-to-parent');
			
			$(this).next("ul").slideDown();
			$(this).addClass('back-to-parent')
		}
	}); 
} 

function openNav() {
	$('#mobile-menu').toggleClass('opened');
	$('#mobile-menu-close').addClass('active');
	//document.getElementById("page-container").style.marginLeft = "50px";
	//document.getElementById("topbar-mobile").style.marginLeft = "50px";
}
function closeNav() {
	$('#mobile-menu').toggleClass('opened');
	$('#mobile-menu-close').removeClass('active');
	//document.getElementById("page-container").style.marginLeft = "0px";
	//document.getElementById("topbar-mobile").style.marginLeft = "0px";
	//document.getElementById("topbar-mobile").style.marginLeft = "0px";
}

var ScrollNav = function(){

    var navbar = $("#site-header, #cart-dropdown");
	var navbarHeight = navbar.outerHeight();
    var navbarMobile = $("#topbar-mobile");
	var messagebar = $('#site-header .message-bar');
	var messagebarHeight = $('#site-header .message-bar').outerHeight();
	if ($(window).width() < screen_small) {
		var messagebarHeight = $('#topbar-mobile .message-bar').outerHeight();
	}
	
	const AddToCart = document.getElementById('AddToCart');
	const AddToCartSticky = document.getElementById('sticky-add-to-cart');
	
	let distanceFromTop = 0;
	if (AddToCart) {
		const position = AddToCart.getBoundingClientRect();
		distanceFromTop = position.top + position.height;
	}
	
	function hasScrolled() {
		var st = $(this).scrollTop();
		if (st > 20){
			navbar.addClass('min');  
			navbarMobile.addClass('scrolled')
			$('.message-bar').css('margin-top','-'+messagebarHeight+'px');
		} else  { 
			navbar.removeClass('min');
			navbarMobile.removeClass('scrolled')
			$('.message-bar').css('margin-top','0px');
		}
		
		const AddToCart = document.getElementById('AddToCart');
		if (AddToCart) {
			if ($(window).width() < screen_small) {


				if (st > distanceFromTop){
					AddToCartSticky.classList.add('stick')
				} else {
					AddToCartSticky.classList.remove('stick')
				}
			}
		}
	} 
  
	$(window).scroll(function(event){
        hasScrolled();
	});

    hasScrolled();
} 
function topFunction() {
	// When the user clicks on the button, scroll to the top of the document
	document.body.scrollTop = 0; // For Chrome, Safari and Opera 
	document.documentElement.scrollTop = 0; // For IE and Firefox
}

function headerCountdown() {
	if (typeof countDownDate !== 'undefined') {
				
	    // Update the count down every 1 second
	    var x = setInterval(function() { 

	      // Get today's date and time
	      var now = new Date().getTime();

	      // Find the distance between now and the count down date
	      var distance = countDownDate - now;

	      // Time calculations for days, hours, minutes and seconds
	      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
	      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
	      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

	      // If the count down is finished, hide
		  if (distance < 0) {
			  clearInterval(x);
			  $('.countdown-timer').hide()
		  } else {
			  $('.countdown-timer').html(days + "d " + hours + "h "
			  + minutes + "m " + seconds + "s ");
		  }

	    }, 1000);
	}
	
	if (typeof countDownDateNewsletter !== 'undefined') {
		setTimeout(function(){
			$('.countdown-newsletter').css('opacity', '1');
		}, 	1000);
		
		// Get the browser's timezone offset in milliseconds
		var timezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
		
		
		// Update the count down every 1 second
		var x = setInterval(function() { 

			// Get today's date and time
			var now = new Date().getTime();
			
			now += timezoneOffset;

			// Find the distance between now and the count down date
			var distance = countDownDateNewsletter - now;

			// Time calculations for days, hours, minutes and seconds
			var days = Math.floor(distance / (1000 * 60 * 60 * 24));
			var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			var seconds = Math.floor((distance % (1000 * 60)) / 1000);

			// If the count down is finished, hide
			if (distance < 0) {
				clearInterval(x);
				$('.countdown-newsletter').hide()
			} else {
				$('.countdown-newsletter').html(`
					<div><span>`+days+`</span><label>DAYS</label></div>:
					<div><span>`+hours+`</span><label>HOURS</label></div>:
					<div><span>`+minutes+`</span><label>MIN</label></div>:
					<div><span>`+seconds+`</span><label>SEC</label></div>`);
				} 
			}, 1000);

		}
}

function klaviyoRadios(){
	$('#klaviyo-signup').on('click', 'label', function() {
		$('#klaviyo-signup label').removeClass('selected')
		$(this).addClass('selected')
	}); 
}



$('.email_signup_klaviyo').submit(function(e) {
	e.preventDefault();
		
	$form = $(this)

	$(".error").remove();
	hasError = false

	const emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
	let emailaddressVal = $form.find('.k_id_email').val();
	let genderRadio = $form.find('input[name=gender]:checked');
	let k_constent = [''];
	let sms_content = false

	if (emailaddressVal == '') {
		error_message = 'Please enter an email address'
		$form.find('.input-group').after('<p class="error">Please enter your email address.</p>');
		hasError = true;
	} else if (!emailReg.test(emailaddressVal)) {
		$form.find('.input-group').after('<p class="error">Enter a valid email address.</p>');
		hasError = true;
	}
			
	if ( hasError == false ) {	
		
		const options = {
			method: 'POST',
			headers: {revision: '2023-10-15', 'content-type': 'application/json'},
			body: JSON.stringify({
				data: {
					type: 'subscription',
					attributes: {
						custom_source: $form.data('source'),
						profile: {
							data: {
								type: 'profile',
								attributes: {
									email: emailaddressVal
								}
							}
						}
					},
					relationships: {list: {data: {type: 'list', id:  $form.data('list') }}}
				}
			})
		};
			
		console.log( options )

		fetch('https://a.klaviyo.com/client/subscriptions/?company_id=QGFR4N', options)
			.then(response => response.json())
			.then(response => console.log(response))
			.catch(err => console.error(err));
			
		
		/*
		
		$.ajax({
			async: true,
			crossDomain: true,
			url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
			method: "POST",
			headers: {
				"content-type": "application/x-www-form-urlencoded",
				"cache-control": "no-cache"
			}, 
			data: {
				g: klaviyo_list,
				$fields: "$source, $consent, email, $phone_number, sms_consent, Customer Newsletter Preference, Accepts Marketing",
				$source: $form.data('source'),
				$consent: k_constent,
				email: emailaddressVal,
				$phone_number: $form.find('.k_id_phone').val(),
				"sms_consent": sms_content,
				'Customer Newsletter Preference': genderRadio.val(),
				'Accepts Marketing': true
			}, 
			success: function(response){
				$form.html("<div class='email-success'><h3>"+k_success_title+"</h3><p>"+k_success_message+"</div>");
			}
		});
		*/
			
	}
});



$('.email_signup').submit(function(e) {
	e.preventDefault();
		
	$form = $(this)

	$(".error").remove();
	hasError = false

	const emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
	let emailaddressVal = $form.find('.k_id_email').val();
	let genderRadio = $form.find('input[name=gender]:checked');
	let k_constent = [''];
	let sms_content = false

	if (emailaddressVal == '') {
		error_message = 'Please enter an email address'
		$form.find('.input-group').after('<p class="error">Please enter your email address.</p>');
		hasError = true;
	} else if (!emailReg.test(emailaddressVal)) {
		$form.find('.input-group').after('<p class="error">Enter a valid email address.</p>');
		hasError = true;
	}
			
	if (genderRadio.length === 0) {
		$form.find('.signup-gender').append('<p class="error">Please select a gender preference.</p>')
		hasError = true;
	}
		
	if ( $( $form.find('.k_sms_content') ).is(':checked') ){
		k_constent = ['sms'];
		sms_content = true
	}

	if ( hasError == false ) {	
		$.ajax({
			async: true,
			crossDomain: true,
			url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
			method: "POST",
			headers: {
				"content-type": "application/x-www-form-urlencoded",
				"cache-control": "no-cache"
			}, 
			data: {
				g: klaviyo_list,
				$fields: "$source, $consent, email, $phone_number, sms_consent, Customer Newsletter Preference, Accepts Marketing",
				$source: $form.data('source'),
				$consent: k_constent,
				email: emailaddressVal,
				$phone_number: $form.find('.k_id_phone').val(),
				"sms_consent": sms_content,
				'Customer Newsletter Preference': genderRadio.val(),
				'Accepts Marketing': true
			}, 
			success: function(response){
				$form.html("<div class='email-success'><h3>"+k_success_title+"</h3><p>"+k_success_message+"</div>");
				
				if ( $form.data('source') == 'popup' ) {
					$('#newsletter-popup .intro').hide();
				}
				
				setCookie('newsletter-popup', 'true', 3000);
				ga('send', 'event', {
					eventCategory: 'Marketing',
					eventAction: 'Signup',
					eventLabel: $form.data('source')
				});
			}
		});
	}
});

$('.footer-slide-nav a').click(function(){
	$('.footer-slide-nav a').removeClass('active');
	$(this).addClass('active');
});



$('#newsletter-popup .step-1').click(function() {
	$(this).fadeOut();
	$('#newsletter-popup').addClass('active');	
	ga('send', 'event', {
		eventCategory: 'Marketing',
		eventAction: 'Popup',
		eventLabel: 'Interest'
	});
}); 
/* CART */ 
function ajax_add(variantId,button){
	$.ajax({
		url: '/cart/add.js', 
		dataType: 'json',
		type: 'post',
		data: {
			quantity:1, 
			id: variantId
		}, 
		success: function(itemData) { 
			build_cart(button);  
			//Pinterest Add To Cart Tracking
			pintrk('track', 'addtocart')
		}, 
		error: function(XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
			console.log("Error: " + response);
			alert('All items are already in your cart');
			if (typeof button !== 'undefined') {
				button.html('Add To Cart') 
			}
			
		}
	});
}

function addProductToCart(variantId, $form){	 
	
	button = $form.find('button[type="submit"]')
	
	button.html('<span class="loader delay-2"></span><span class="loader delay-1"></span><span class="loader"></span>')
	
	if (store_location == 'au' ) {
		//Google Ads conversion tracking added for Damien 29/1/21
		function gtag_report_conversion(url) {
			var callback = function () {
				if (typeof(url) != 'undefined') {
					window.location = url;
				}
			};
			gtag('event', 'conversion', {
				'send_to': 'AW-880517883/tbO_CLzo-vIBEPvF7qMD',
				'event_callback': callback
			});
			return false;
		}
	}
	
	$('.header-cart icon').addClass('cart-full');
	
	ajax_add(variantId,button);
} 

$(".product_form.ajax").submit(function(e) {
	e.preventDefault();
	var addToCartForm = $(this);  
	selected_variant = addToCartForm.find("select[name=id] option:selected").val();    
	addProductToCart(selected_variant, addToCartForm);
});

$(".product_form.qv").submit(function(e) {
	e.preventDefault();
	var $addToCartForm = $(this);  
	selected_variant = $(this).find(".size-swatches input[type='radio']:checked").val();
	//console.log("selected: " + selected_variant);
   
	addProductToCart(selected_variant, $addToCartForm);
});

function show_cart(){
	$('body').addClass('cart-active')
}

$('.header-cart').click(function(e){
	e.preventDefault()
	build_cart()
})

$('#cart-drawer-overlay, #close_cart').click(function(){
	$('body').removeClass('cart-active')
});

function add_free_product(free_product_id) {
	$('#cart-loader span').addClass('loading');
	$.ajax({
		url: '/cart/add.js', 
		dataType: 'json',
		type: 'post',
		data: {
			quantity:1, 
			id:free_product_id
		}, 
		success: function(itemData) { 
			build_cart()
		}, 
		error: function(XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
			console.log("Error: " + response);

		}
	}).done(function() {
		if (window.location.href.indexOf('/cart') != -1) {
			location.reload(); 
		} else {
			$('#cart-loader span').removeClass('loading');
		}
	});
}

if ($(window).width() < screen_small) {
	$('#cart_page_form').addClass('vertical')
}

let reward_id = ''
let reward_tier = ''

//console.log(reward_tiers)

function rewards_load(){
	reward_id = ''
	reward_tier = ''
	 
	if (typeof reward_tiers !== "undefined") {
		$.each(reward_tiers, function(i, tier) {	
			//console.log(tier)
	
			if ( reward_id == '' ){
				if ( tier.claimed == false && tier.min < customer_spend && tier.max > customer_spend ) {
					reward_id = parseInt(tier.reward);
					reward_tier = tier.name;
				}
			}
		});
	
		if ( reward_id != '' ) {
			rewards_check_cart();
		}
	}
}

function rewards_check_cart(){
	fetch(window.Shopify.routes.root + 'cart.js')
	.then((response) => {
		return new Promise((resolve) => response.json()
		.then((json) => resolve({
			status: response.status,
			ok: response.ok,
			json,
		})));
	}).then(({ status, json, ok }) => {
		switch (status) {
		case 400:
			alert('400 error');
			break;
		case 201:
			break;
		case 200:
			console.log(json);
			
			let cart_contains_reward = false
			$.each(json.items, function(i, item) {
				if ( item.id == reward_id) {
					cart_contains_reward = true
				}
			});
			
			if ( cart_contains_reward == false ) {
				rewards_add_product();
			}
			
			break;
		case 500:
			break;
		default:
			//Any default tasks
		}
	})
}

/*
Build but using Yotpo instead
function rewards_add_product() {
	product_data = {
		quantity:1, 
		id: reward_id,
		properties: {
			'Reward': reward_tier
		}
	}

	fetch('/cart/add.js', {
		method: 'POST',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest'
		},
		body: JSON.stringify(product_data)
	}).then((response) => {
		return new Promise((resolve) => response.json()
		.then((json) => resolve({
			status: response.status,
			ok: response.ok,
			json,
		})));
	}).then(({ status, json, ok }) => {
		switch (status) {
		case 400:
			console.log('product unavailable');
			break;
		case 201:
			break;
		case 200:
			console.log('product added');
			console.log(json);
			build_cart();
			break;
		case 500:
			break;
		default:
			//Any default tasks
		}
	}) 
}

rewards_load();
*/
function load_cart_promos(){	
	
	var cart_promo_val = free_ship_aud
	if ( cart_currency == 'NZD' ) {
		cart_promo_val =  free_ship_nzd
	} else if ( cart_currency == 'SGD' ) {
		cart_promo_val =  free_ship_sgd
	} else if ( cart_currency == 'HKD' ) {
		cart_promo_val =  free_ship_hkd
	} else if ( cart_currency == 'JPY' ) {
		cart_promo_val =  free_ship_jpy
	} else if ( cart_currency == 'USD' ) {
		cart_promo_val =  free_ship_usd
	} else if ( cart_currency == 'CAD' ) {
		cart_promo_val =  free_ship_cad
	} else if ( cart_currency == 'EUR' ) {
		cart_promo_val =  free_ship_eur
	}
	var free_product_qualified = false;
	var free_product_in_cart = false; 
	 
	$.ajax({
		type: 'GET',
		url: '/cart?view=data',
		success: function(cart) {
			cart = JSON.parse(cart);
			
			//console.log('successs')
			//console.log(cart);  
			
			cart_promo_dif = cart_promo_val - cart.original_total_price
			
			//If we set a free product with purchase
			if (typeof free_product_cart_val != 'undefined') {
								
				cart_promo_dif = free_product_cart_val - cart.original_total_price
				cart_promo_val = free_product_cart_val
				$('.free-cart-product').html(free_product_text)

				if ( cart_promo_dif < 0 ) {
					free_product_qualified = true
				}
			}
			
			$('#free-ship-val').html( money(cart_promo_dif) )
			
			if ( cart_promo_dif > 0 ) {
				$('.draw-free-shipping .qualified').hide()
				$('.draw-free-shipping .unqualified').fadeIn()
			} else {
				$('.draw-free-shipping .unqualified').hide()
				$('.draw-free-shipping .qualified').fadeIn() 				
			}
			
			//Percentage bar
			cart_promo_percent = 10000 / cart_promo_val			
			cart_total_price = cart.original_total_price / 100
			cart_promo_percent = cart_promo_percent * cart_total_price
			$('.draw-free-shipping span').css('width', cart_promo_percent+'%')
			
			let
				show_charities = false,
				cart_full_price = 0
			
			//Loop over current cart items
			$(cart.items).each(function (i, item) {	
				//Check for fundraising products
				if (typeof fundraising_products !== 'undefined') {
					if ( item.title.indexOf(fundraising_products) != -1) {
						show_charities = true
					}
				}
				
				//Check if product with tag is in cart
				if (typeof free_product_cart_tag != 'undefined') {
					const title = item.title;
					if ( title.includes(free_product_cart_tag) ) {
						free_product_qualified = true
					}
				}
								
				//If qualified for free product, see if its already in the cart
				if (free_product_qualified && typeof free_product_id != 'undefined') {
					if ( (free_product_id.indexOf(item.handle) != -1) || (free_product_id.indexOf(item.id) != -1) ) {
						free_product_in_cart = true
					}
				}
			});
						
			//Offer free products
			if ( (free_product_qualified) && (!free_product_in_cart) ){
				if ( free_product_id.indexOf(',') != -1) {
					//If multiple options show popup
					$('#cart-promo-popup').show();			
					$('#cart-promo-popup').addClass('active')			
				} else {
					//else add automatically
					console.log('q:'+free_product_qualified)
					add_free_product(free_product_id)
				}
			}
			
			$('#cart-charity').empty();
			if (show_charities) {				
				$('#cart-charity').show();
				$('#cart-drawer .w3-donation-tracker').clone().appendTo('#cart-drawer #cart-charity');
			} else {
				$('#cart-charity').hide();
			}
			
			//Update cart count
			$('.header-cart span').html(cart.item_count)
			
		},
		error: function(status) {
			console.warn( 'ERROR', status );
		}
	}).done(function() {
		if (typeof button !== 'undefined') {
			button.html('Add To Cart') 
		}
		$('#cart-loader span').removeClass('loading');
		//
		//rewards_load();
	});
}
 
function build_cart(button){	
	let open_cart = true;
	fetch('/cart/?sections=cart')
	.then(response => response.text())
	.then(html => {
		console.log( JSON.parse(html) )
	
		parsedHTML = JSON.parse(html)
		//console.log('new cart:')
	
		const parsedCart = parsedHTML.cart
	
		var parser = new DOMParser();
		var cartHTML = parser.parseFromString(parsedCart, 'text/html');
	
		const cart_table = cartHTML.querySelector('.cart-table');
		const cart_checkout = cartHTML.querySelector('.checkout-panel'); 
	
		document.getElementById("cart_drawer_form").innerHTML = "";
		
		if ( cart_table == null ) {			
			open_cart = false;
			document.getElementById("cart_drawer_form").innerHTML = "<h3 style='margin-bottom: -20px;'>Cart empty</h3><p>There are no items in your cart.</p>";
			$('.additional-checkout-buttons, .draw-free-shipping').hide();
		} else {			
			document.getElementById("cart_drawer_form").appendChild(cart_table).appendChild(cart_checkout);
			$('.additional-checkout-buttons, .draw-free-shipping').fadeIn();
		}	
		if (open_cart == true) {
			load_cart_promos();	
			show_cart();
		}
	})
	.catch(e => {
		console.error(e);
	});
}

load_cart_promos();

$('#free-gift .AddToCart').click(function(){
	add_free_product( $(this).closest('.product-item').find('select').val() );
	$('#cart-promo-popup').removeClass('active');	
});

function update_cart_item(obj, new_qty){
	var cart_item = obj.closest('.cart-table-row');
	var item_var_id = cart_item.data('id');
	
	$('#cart-loader span').addClass('loading');
	
	/*
	$.ajax({
		url: '/cart/change.js', 
		dataType: 'json',
		type: 'post',
		data: {
			quantity: new_qty, 
			id: item_var_id
		}, 
		success: function(cart) { 
			alert(JSON.stringify(cart));
			//console.log(cart)
			build_cart();
		}, 
		error: function(XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
			console.log("Error: " + response);
			alert('fail: ' + XMLHttpRequest.responseText )
		}
	}).done(function() {
		//any done functions?
	});*/
	
	var change_product_data = {
		"id": item_var_id.toString(),
		"quantity": new_qty
	};
	
	console.log( change_product_data )
		
	fetch('/cart/change.js', {
		method: 'POST',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(change_product_data)
	})
	.then(response => {
		//return response.json();
	  
		//alert(JSON.stringify( response ) );
		console.log(response.json())
		build_cart();
	  
	})
	.catch((error) => { 
		console.log((error))
		alert.error('Error:', error);
	});
	
}

$('#cart-drawer').on('click', '.add', function() {
	qty_input = $(this).closest('.cart-table-row').find('input.quantity')
	item_qty = parseInt(qty_input.val());	
	new_qty = item_qty + 1
	qty_input.val(new_qty)  
	update_cart_item($(this), new_qty)
});

$('#cart-drawer').on('click', '.minus', function() {
	qty_input = $(this).closest('.cart-table-row').find('input.quantity')
	item_qty = parseInt(qty_input.val());
	new_qty = item_qty - 1
	qty_input.val(new_qty) 	
	update_cart_item($(this), new_qty)
});

$('#cart-drawer').on('change', '.cart-qty input', function() {
	new_qty = $(this).val()
	update_cart_item($(this), new_qty)
});

$('#cart-drawer').on('change', '.cart-qty input', function() {
	new_qty = $(this).val()
	update_cart_item($(this), new_qty)
});

$('#cart-drawer').on('click', '.remove', function() {
	new_qty = 0
	update_cart_item($(this), new_qty)
});

function update_cart_input(obj, change){
	qty_input = obj.closest('.cart-qty').find('.quantity')
	qty_input.val( parseInt(qty_input.val()) + change)
	$('.update-cart').trigger('click');
}

$('.cart-table .add').click(function(){
	update_cart_input($(this), 1)
}); 

$('.cart-table .minus').click(function(){
	update_cart_input($(this), -1)
});
 
$('.cart-table .remove').click(function(e){
	e.preventDefault();
	qty_input = $(this).closest('.cart-product-info').find('.quantity')
	qty_input.val(0)
	$('.update-cart').trigger('click');
});
 
$('.cart-table input').on('input', function() {
	$('.update-cart').trigger('click');
});

//Free Product Popup 
function Popup(){	
 	$('.popup-wrapper:not(.no-close)').click(function(e) {
 		if(e.target !== e.currentTarget) return;
 		e.preventDefault();
 		$(this).fadeOut();
 	}); 
	
 	$(".close-popup").click(function(e) {
		if(e.target !== e.currentTarget) return;
 		e.preventDefault();
 		$(this).closest(".popup-wrapper").fadeOut();
 	});
}


// CART FUNCTIONS //

$(function() {
	$("#cart_form input[type='number']").change(function() {$("#cart_form").submit(); });
});

$(".add.button, .minus.button").on("click", function() {
	var $button = $(this);
	var oldValue = $button.parent().find("input.quantity").val();

	if ($button.text() == "+") {
		var newVal = parseFloat(oldValue) + 1;
	} else {
		// Don't allow decrementing below zero
		if (oldValue > 0) {
			var newVal = parseFloat(oldValue) - 1;
		} else {
			newVal = 0;
		}
	}
	$button.parent().find("input").val(newVal).change();
});

$('#cart-promo-popup .buttons-wrap button,#cart-promo-popup .close-popup').click(function(){
	$('#cart-promo-popup').removeClass('active')
});

$('#cart-drawer .action_button').click(function(){
	$(this).html('<span class="loader delay-2"></span><span class="loader delay-1"></span><span class="loader"></span>')
});

$('body').on('click', '.quick-add-btn:not(.open)', function(e) {
	e.preventDefault();	
	
	$(this).addClass('open').html('<span>CANCEL</span>');
	
	const product_obj = $(this).closest('.product-item')
	const product_url = product_obj.find(".info-container a").attr('href');
	const quick_add = product_obj.find(".quick-add");
	
	fetch( product_url+".json" )
	.then((response) => {
		return new Promise((resolve) => response.json()
		.then((json) => resolve({
			status: response.status,
			ok: response.ok,
			json,
		})));
	}).then(({ status, json, ok }) => {
		const product = json.product;
		
		console.log( product )
		
		quick_add.html('');
		$.each(product.variants, function(i, v) {
			let availability = ''
			if ( v.inventory_quantity < 1 ) {
				availability = ' disabled'
			}
			quick_add.append('<button type="button" data-id="'+v.id+'"'+availability+'>'+convert_size(product.title,v.title)+'</button>');
		});	

		quick_add.css('display','flex');
	}) 
});
 
$('body').on('click', '.quick-add-btn.open', function(e) {
	$(this).removeClass('open').html('<span>QUICK ADD +</span>');
	const product_obj = $(this).closest('.product-item')
	const quick_add = product_obj.find(".quick-add");
	quick_add.css('display','none');
});
 
$('body').on('click', '.quick-add button:not(:disabled)', function(e) {
	e.preventDefault();	
	ajax_add(parseInt($(this).data('id')));	
});

/* HOME PAGE */

function playVideos() {
	//$('.section-video').find('video.small--hide').trigger('play');
		
	if ($(window).width() < screen_small) {
		$('.autoplay').find('video.large--hide').trigger('play'); 
	} else {
		$('.autoplay').find('video.small--hide').trigger('play');
	} 
	
	$('.autoplay.all-devices').find('video').trigger('play');
	
	$('.section-video .sound').click(function(){
		this_video = $(this).closest('.section-video')
		this_video.find('video').prop('muted', false)
		this_video.find('.sound').hide();	
		this_video.find('.mute').show();	
	});
	$('.section-video .mute').click(function(){
		this_video = $(this).closest('.section-video')
		this_video.find('video').prop('muted', true)
		this_video.find('.mute').hide();	
		this_video.find('.sound').show();	
	});
	
	$('.section-video .play').click(function(){
		this_video = $(this).closest('.section-video')
		this_video.find('video').trigger('play')
		this_video.find('.play').hide();	
		this_video.find('.pause').show();	
	});
	
	$('.section-video .pause').click(function(){
		this_video = $(this).closest('.section-video')
		this_video.find('video').trigger('pause')
		this_video.find('.pause').hide();	
		this_video.find('.play').show();	
	});
}

function homepageAnimations(){
	if ($(window).width() < screen_large) {
	
		$(window).scroll(function(){
			$('.block-link').each(function(){
				var offsetTopPosition = $(this).offset().top - $(window).scrollTop();
				var current_block = $(this).find('.block-overlay');

				if (offsetTopPosition < 400) {
					$(current_block).addClass('active');
				} else {
					$(current_block).removeClass('active');
				}
			
				if (offsetTopPosition < 100) {
					$(current_block).removeClass('active');
				}	
			});
		});
	}
} 

function sectionHighlights(){
	$('.highlights-nav button').click(function(){
		const value = $(this).attr('data');
		$('.highlights-nav button').removeClass('active')
		$('#highlights-'+value).addClass('active')
		
		$('.highlights-list').removeClass('active')
		$('#highlights-cat-'+value).addClass('active')
	});
}

$('.signup_btn').click(function(){
	$(this).hide();
	$(this).closest('.section--newsletter').find('.form-wrap').show();
});

/* COLLECTION PAGE */
function collectionProductFunctions(){
	
	$(".product-item .swatches").unbind().on("click", "a", function(e){
		e.preventDefault();
		const collection_url = $(this).closest('.product-grid').data('handle');
			
		fetch( $(this).attr('href')+".json" )
		.then((response) => {
			return new Promise((resolve) => response.json()
			.then((json) => resolve({
				status: response.status,
				ok: response.ok,
				json,
			})));
		}).then(({ status, json, ok }) => {		
			console.log( json )
			const
				swatch = $(this),
				product = json.product,
				product_obj = swatch.closest(".product-item");
		
			const
				img = product_obj.find(".product-image img"),
				product_price = product_obj.find('.price'),
				product_compare = product_obj.find('.del-price'),
				quick_add = product_obj.find(".quick-add");
			
			swatch.parent().find("a").removeClass("selected");
			swatch.addClass("selected");
		
			//console.log(product)

			img.attr("src", product.images[0].src.replace('.png','_600x.png') );
			img.data("image1", product.images[0].src.replace('.png','_600x.png') );
			img.data("image2", product.images[1].src.replace('.png','_600x.png') );
	
			const
				compare_at = parseInt(product.variants[0].compare_at_price * 100),
				price = parseInt(product.variants[0].price * 100);
	
			product_price.html( money(price) )
	
			if ( compare_at !== null ){
				product_compare.html( money(compare_at) )
		
				if (compare_at > price) {
					product_price.addClass('reduced')
					product_compare.removeClass('hide')
				} else {
					product_price.removeClass('reduced')
					product_compare.addClass('hide')
				}
			} else {
				product_price.removeClass('reduced')
				product_compare.addClass('hide')
			}		
			product_obj.find(".product-image, .info-container a").attr('href', '/collections/'+collection_url+'/products/'+product.handle);
			
			const title_parts = product.title.split(' - ')
			
			product_obj.find(".subtitle").text(title_parts[1]);
		
			quick_add.html('');
			$.each(product.variants, function(i, v) {
				let availability = ''
				if ( v.inventory_quantity > 0 ) {
					availability = ' disabled'
				}
				quick_add.append('<button type="button" data-id="'+v.id+'"'+availability+'>'+convert_size(product.title,v.title)+'</button>');
			});
		
		}) 
	});
}

var SecondImageRollovers = new function(){  
	this.initRollovers = function(){		
		$(".product-image img").hover(function() {
			//first time add image1 for post hover
			if ( $(this).attr("data-image1" ) === undefined) {
				$(this).attr("data-image1", $(this).attr("src"));
			}
			if ($(this).data("image2")){
				$(this).attr("src", $(this).data("image2"));
			}
		},function() {
			$(this).attr("src", $( this).data("image1"));
		}); 
	}
}

Shopify.queryParams = {};

function checkQueryParams(){
	// Preserve existing query parameters
	if (location.search.length) {
		var params = location.search.substr(1).split('&');

		for (var i = 0; i < params.length; i++) {
			var keyValue = params[i].split('=');

			if (keyValue.length) {
				Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
			}
		}
	}
}

// Update sort_by query parameter on select change

const sortBySelect = document.getElementById('SortBy')
if ( sortBySelect != null ) {
	sortBySelect.addEventListener('change', function(e) {
		var value = e.target.value;
	
		checkQueryParams();

		Shopify.queryParams.sort_by = value;
		location.search = new URLSearchParams(Shopify.queryParams).toString();
	});
}

function QuickView(){
	
	if ($(window).width() > screen_large) {
		$(document).on('mouseenter', '.qv-enabled .product-item', function() {
			$( this ).find('.product-image').append($('<div class="quickview"><button type="button"><span>Quick View</span> +</button></div>'));
			$( this ).find('.quickview').addClass('animate');
		});
		
		$(document).on("mouseleave", ".product-item", function() {
			$( this ).find( ".quickview" ).remove();
		});
	}
	
	function updateProductData (qv_preorder){
		var selectedOptions = null;   
		
		selected_variant = $("#quick-view .size-swatches input[type='radio']:checked").val();
		product_handle = product_handle.split('products/').pop();
		
		jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
			$(product.variants).each(function (i, variant) {
				
				if (variant.id == selected_variant) {
					var v_inv = variant.inventory_management;
				 
					$('#quick-view .current_price').empty().html( money(variant.price) );
					$('#quick-view .was_price').empty().html( money(variant.compare_at_price) );
					
					if (v_inv == null) {
						$('#quick-view .add_to_cart').prop('disabled', false).find('.text').text('Add to Cart');
					} else {
						if (variant.available) {
							let atc_btn_txt = 'Add to Cart'
							if ( qv_preorder ) {
								atc_btn_txt = 'Pre-order'
							}
							$('#quick-view .add_to_cart').prop('disabled', false).find('.text').text(atc_btn_txt);
						} else {
							$('#quick-view .add_to_cart').prop('disabled', true).find('.text').text('Sold Out');
						}
					}
					
					if (parseInt(variant.price) < parseInt(variant.compare_at_price)) {
						$('#quick-view .was_price').show();
					} else {
						$('#quick-view .was_price').hide();
					}
				}
			});
		}).done(function(data) {	
			
		});
		
	
		
	} 
	
	function QuickViewPopup(product_handle, product_img){
		product_handle = product_handle.split('/');
		product_handle_full = $(product_handle).last()[0];
		product_handle_parts = product_handle_full.split('?');
		product_handle = product_handle_parts[0];
		
		collection_handle = $('.product-grid').data('handle');
		
		$('#qv-img').attr('src', loading_placeholder);
		$('#quick-view').append('<div class="qv-loader"></div>').fadeIn();
		
		let qv_preorder = false;
		
		jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
											
			product_object = {
				"handle":product.handle.toString(),
				"price": product.price.toString()
			} 
			browsingHistory(product_object)
			
			prodTitle = product.title
			prodTitleParts = prodTitle.split(' - ')
			prodTitle = prodTitleParts[0].replace('Afends','').replace('Unisex','').replace('Mens','').replace('Womens','');
			productColour = prodTitleParts[2];

			price = 0;
			original_price = 0;
			url = '/collections/' + collection_handle + '/products/' + product_handle_full;
					
			if (productColour == null) {
				//Fallback if no colour is selected redirect to product page
				//window.location.href = product_url;
			} else {			
				$('#qv-title, #out-of-stock h4').html(prodTitle);
				$('#qv-subtitle, #out-of-stock h5').html(prodTitleParts[1]);
				
				$('#qv-img').attr('src', product_img); 
				$('.view-product').attr('href', url); 

				$('#quick-view .product_form').data('id', product.id);
		
				$('.qv-product-options').empty();
				$('.qv-shipping-date').empty();
				$('#productSelect').empty();
				$('#qv-variants').empty();
				
				$('#NotifyMe').hide();
				$('.add_to_cart').show();
			
				var option_quantity = 0 
				
				//Create Swatches 
				$(product.options).each(function (i, option) {
					var opt = option.name.toLowerCase();
					var opt_index = i;
					option_quantity = option_quantity + 1;
					
					css_class = 'swatch-selection clearfix ' + opt + '-swatches';
					if (product.options.length == 1) {
						css_class = css_class+' single-option';
					}
		
					$('.qv-product-options').append('<h6 class="' + opt + '-heading">' + opt + '</h6><div class="'+css_class+'"></div>');
		
					$(option.values).each(function (i, value) {
												
						var value = value.toLowerCase();
						var value_handle = value.replace(' ','-');
						var value_converted = convert_size(product.title,value)
						
						$('.' + opt + '-swatches').append('<div class="swatch" data-value="' + value + '" data-option-index="' + opt_index +'"><input type="radio" name="option-' + opt + '" id="option-' + opt + '-' + value_handle + '" value="' + value + '"><label for="option-' + opt + '-' + value_handle + '">' + value_converted + '</label></div>');
					});
				});
				
				$(product.tags).each(function (i, tag) {
					if (tag.indexOf('available:') > -1) {
						qv_preorder = true
						$('.qv-shipping-date').html('please note: this item is due to ship on '+tag.replace('available:',''));
					}
				});
				
				//Hide sizes if there is only 1 choice
				if( $('#quick-view .size-swatches .swatch').length == 1) {
					$('#quick-view .size-swatches').hide();
				} else {
					$('#quick-view .size-swatches').show();
				}
								
				$(product.variants).each(function (i, variant) {
					if (option_quantity == 1) {
						//v2 products with 1 variant option
						
						var var_option_1 = variant.options[0].toLowerCase().replace(' ','-');
				
						if (variant.available){							
							$('#quick-view .size-swatches .swatch').each(function (i) {
								if($(this).data('value') == var_option_1) {
									$(this).removeClass("soldout");
									$(this).find("input").prop('disabled', false).val(variant.id).attr('data-qty', variant.inventory_quantity);
								}
							});
						} else {
							$('#quick-view .size-swatches .swatch').each(function (i) {
								if($(this).data('value') == var_option_1) {
									$(this).addClass('soldout');
									$(this).find("input").prop('checked', false).val(variant.id).attr('data-qty', variant.inventory_quantity);
									//Removed the disabled attriubte because we have #notifyme back in stock button
									//$(this).find("input").prop('disabled', true);
								}
							});
						}
					
					} else {
						
						//If we ever have products with 2 variant options
						var var_option_1 = variant.options[0].toLowerCase().replace(' ','-');
						var var_option_2 = variant.options[1].toLowerCase().replace(' ','-');
					
						if(var_option_2 == productColour){
					
							if (variant.available){
								$('#quick-view .size-swatches .swatch').each(function (i) {
									if($(this).data('value') == var_option_1) {
										$(this).removeClass("soldout");
										$(this).find("input").prop('disabled', false).val(variant.id).attr('data-available', 'true');
									}
								});
							} else {
								$('#quick-view .size-swatches .swatch').each(function (i) {
									if($(this).data('value') == var_option_1) {
										$(this).addClass('soldout');
										$(this).find("input").prop('checked', false).val(variant.id).attr('data-available', 'true');
									//Removed the disabled attriubte because we have #notifyme back in stock button
									//$(this).find("input").prop('disabled', true);
									}
								});
							}
						}
					}
				});
			}
		}).done(function() { 
			variant_reorder(); 
			$(".size-swatches .swatch:not(.soldout):first input").prop('checked', true).attr('checked',true).change();
			checkSwatches();
			
			$('.colour-swatches').find('#option-'+productColour).attr('checked',true);
			
			updateProductData(qv_preorder);			
			$('.qv-loader').remove();
			$('#qv-container').addClass('active');
			
			ga('send', 'event', {
				eventCategory: 'Quick Shop',
				eventAction: product_handle,
				eventLabel: 'Viewed Product'
			}); 
		});
	
		$(document).on("change", "#quick-view .qv-product-options input", function () {
			updateProductData();
		});
	}
	
	$('body').on('click', '.quickview button', function(e) {
		console.log('triggered')
		e.preventDefault();	
		img = $(this).closest('.product-item').find('.product-image img').attr('src');
		product_handle = $(this).closest('a').attr('href');
		QuickViewPopup(product_handle, img);
	});
	
	$('.product-tag').bind('touchstart', function(e){
		e.preventDefault();	
	});
	
	$('.product-tag-info').bind('touchstart', function(e){
		e.preventDefault();	
		img = $(this).closest('.product-tag').data('img');
		product_handle = $(this).closest('.product-tag').data('handle');
		QuickViewPopup(product_handle, img);
	});

	$('.product-tag').click(function(e){	
		e.preventDefault();	
		img = $(this).data('img');
		product_handle = $(this).data('handle');
		QuickViewPopup(product_handle, img);
	});
	
	$('.as-seen-on a').click(function(e) {
		e.preventDefault();
		img = $(this).find('img').attr('src');
		product_handle = $(this).closest('a').attr('href');
		QuickViewPopup(product_handle, img);
	});  
		
	$('body').on("click", "#quick-view", function(e){
	  if( e.target !== this ) {
	       return;
	   } else {
		  $(this).fadeOut();
		  $('#qv-container').removeClass('active');
	   }
	});
	
	$('#close-qv').click(function(){
	  $('#quick-view').fadeOut();
	  $('#qv-container').removeClass('active');
	})
	
	/*
	$('#quick-view').on('click', '.size-swatches input', function(e) {
		//console.log('availability: '+ $(this).data('available') );
		
		$('#NotifyMe').addClass('found');
		if ( $(this).data('available') == false ) {
			console.log('test1')
			$('.notify_me').show();
			$('.add_to_cart').hide();
		} else {
			console.log('test2')
			//$('#NotifyMe').hide();
			$('.add_to_cart').show();
		}
	});	
	*/
}


var filtersLoaded = false

function loadCollectionFilters(collection_url) {
	
	FiltersType = []
	FiltersSize = []
	FiltersColour = []
	
	$.ajax({
		url:	"/collections/"+collection_url+"?view=json",
		type:	'GET'
	})
	.done(function(data) {	  
		$.each(JSON.parse(data).results, function(index, item) {
			if( filtersLoaded == false ) {
				
				if ((item.filterType !== undefined) && (item.filterType !== '')) {
					ProductType = item.filterType
					ProductType = ProductType.split(',');
										
					
					$.each(ProductType, function(key, type) {
						if ( type !== '' ) {
							FiltersType.push(type); 
						}
					}); 
				}		
			
				if ((item.sizes !== undefined) && (item.sizes !== '' )) {
					ProductSizes = item.sizes
					ProductSizes = ProductSizes.split(',');
					$.each(ProductSizes, function(key, size) {
						if ( (size !== '') && (size.indexOf('$') === -1) ) { 
							FiltersSize.push(size);						
							/*
							if (item.title.indexOf('Womens') > -1) {
								if (store_location == 'us' || store_location == 'eu') {
									//Resize womens/unisex universal
									size = size.replace('36', 'aa').replace('28', 'bb').replace('26', 'cc').replace('6', 'XS').replace('8', 'S').replace('10', 'M').replace('12', 'L').replace('14', 'XL').replace('aa', '36').replace('bb', '28').replace('cc', '26');
								}
							
								//Resize wommens bottoms
								if (store_location == 'us') {
									size = size.replace('24', '2').replace('26', '4').replace('28', '6').replace('30', '8').replace('32', '10');	
								}
							
								if (store_location == 'eu') {
									size = size.replace('24', '34').replace('26', '36').replace('28', '38').replace('30', '40').replace('32', '42');	
								}
							} else {
								//Mens Sizing
								if (store_location == 'eu') {
									size = size.replace('28', '34').replace('30', '36').replace('32', '38').replace('34', '40').replace('36', '42');	
								}
							}*/							
						} 
					}); 
				}
				
				if ((item.filterColour !== undefined) && (item.filterColour !== '')) {
					ProductColours = item.filterColour
					ProductColours = ProductColours.split(',');
					
					$.each(ProductColours, function(key, colour) {
						if ( colour !== '' ) {
							FiltersColour.push(colour); 
						}
					}); 
				}
			}
		});
						
		if( filtersLoaded == false ) {
			
			$('.filter-list .loader').hide();
			
			FiltersType = FiltersType.filter(function(elem, index, self) {
				return index === self.indexOf(elem);
			});
			
			//sort alphabetically
			FiltersType.sort(function(a, b){
			    if(a < b) { return -1; }
			    if(a > b) { return 1; }
			    return 0;
			});
		
			if ( FiltersType.length < 2 ) {
				$('#collection-types').hide();
			} else if ( FiltersType.length > 8 ) {
				$('#collection-types').addClass('double')
			}
		
			$.each(FiltersType, function(key, type) {
				type_handle = type.toLowerCase().replace(/ /g,'-');
				$('#collection-types ul').append('<li><input type="checkbox" id="filter-type-'+type_handle+'" name="filter-type-'+type_handle+'" value='+type_handle+'><label for="filter-type-'+type_handle+'">'+type+'</label></li>')
			});
			
			FiltersSize = FiltersSize.filter(function(elem, index, self) {
				return index === self.indexOf(elem);
			}); 

			var ordering = {}, // map for efficient lookup of sortIndex
			sortOrder = ['2', '4', '6,', '8', '10', '12', '14', '30', '32', '34', '36', '38', '40', '42', '44', '46', 'XXS', 'XS', 'S', 'S/M', 'M', 'M/L', 'L', 'L/XL', 'XL', 'XXL', 'OS'];
			for (var i=0; i<sortOrder.length; i++)
				ordering[sortOrder[i]] = i; 

			FiltersSize.sort( function(a, b) {
				//console.log('first: '+a)
				//console.log('second: '+b)
				return (ordering[a] - ordering[b]) || a.localeCompare(b);
			}); 
			
			$.each(FiltersSize, function(key, size) {
				if (size != '') {
					size = size.replace('aa', '36').replace('bb', '28').replace('cc', '26').replace('dd', '6').replace('ee', '8').replace('ff', '10').replace('gg', '12').replace('hh', '14');
					$('#collection-sizes ul').append('<li><input type="checkbox" id="filter-size-'+size+'" name="filter-size-'+size+'" value='+size+'><label for="filter-size-'+size+'">'+size+'</label></li>')
				}
			});
			
			
			FiltersColour = FiltersColour.filter(function(elem, index, self) {
				return index === self.indexOf(elem);
			});
			FiltersColour.sort(function(a, b){
			    if(a < b) { return -1; }
			    if(a > b) { return 1; }
			    return 0;
			});
		
			$.each(FiltersColour, function(key, colour) {
				colour_handle = colour.toLowerCase().replace(/ /g,'-');
				$('#collection-colours ul').append('<li><input type="checkbox" id="filter-colour-'+colour_handle+'" name="filter-colour-'+colour_handle+'" value='+colour_handle+'><label for="filter-colour-'+colour_handle+'">'+colour+'</label></li>')
			});
			
			filtersLoaded = true
		}
	})
	.fail(function(data) {})
	.always(function(data) {
	}); 
}

$('#filter-trigger').click(function() {
	$(loadCollectionFilters($('.product-grid').data('handle')));
	$('#collection-filters').slideToggle();
});

$('#filter-trigger-panel').click(function() {
	$('#filter-panel').toggleClass('active');
});

$('.closer-filter-panel').click(function() {
	$('#filter-panel').removeClass('active');
});

function loadCollectionSwatches(collection_url) {	
	$.ajax({
		url:	"/collections/"+collection_url+"?view=json_swatches",
		type:	'GET'
	})
	.done(function(data) {
		//console.log($.parseJSON(data)); 
	  
		$.each(JSON.parse(data).results, function(index, item) {
			//Find matching products and add swatches 
			$('.product-item').each(function() {
				if (!$(this).find('.swatches').hasClass("loaded")) {
					/* Dev Version
					let product_key = $(this).find('.title').text().trim();
						product_key = product_key.replace(/ /g,'-').replace(/\./g,'-').toLowerCase();
					
					const product_colour = $(this).data('colour');
					const product_type = $(this).data('type');
					
					if (product_key == item.key && product_type == item.type) {	
						const colour_handle = item.colour.replace(' ','-');
						let current_product = ""
						if ( item.colour == product_colour ) {
							current_product = " selected" 
						}
						$(this).find('.swatches').append('<a data-colour="'+item.colour+'" class="'+colour_handle+current_product+'" style="background-image:url('+item.swatch+')" href="/collections/'+collection_url+'/products/'+item.handle+'" data-handle="'+item.handle+'"title="view '+item.colour+'"></a>');
					}
					*/
					product_key = $(this).find('.title').text().trim()+'-'+$(this).find('.subtitle').text().trim();
					product_key = product_key.replace(/ /g,'-').replace(/\./g,'-').toLowerCase();

					//console.log(product_key + ' / ' + item.key) 
					//console.log('Price index: ' + item.priceFilterIndex)

					if (product_key == item.key) {	
						let colour_handle = item.colour.replace(' ','-');
						$(this).find('.swatches').append('<a data-colour="'+item.colour+'" class="'+colour_handle+'" style="background-image:url('+item.swatch+')" href="'+item.url+'" title="view '+item.colour+'"></a>');
					}
				}
				
			});			
		});
		
		$('.swatches:not(.loaded)').each(function() {
			$(this).addClass('loaded')
		});


	})
	.fail(function(data) {})
	.always(function(data) {
		collectionProductFunctions();
	}); 
}

$('.product-grid').each(function( index ) {
	$(loadCollectionSwatches($(this).data('handle')));
});

function AddProduct(i, product, desktop_view, container) {
			
	//Create the product object
	productId = 'product-'+product.id
	prodTitle = product.title
	prodTitle = prodTitle.replace('Afends','').replace('Unisex','').replace('Mens','').replace('Womens','')
	prodTitle = prodTitle.split(' - ') 
	
	product_classes = 'product-item grid__item ' + desktop_view + ' medium--one-half small--one-half'

	firstImage = product.firstImage
	secondImage = product.secondImage
	if ( product.unisex == 'true' ) {
		secondImage = product.thirdImage
		if ( collection_gender == 'womens' ) {
			firstImage = product.secondImage
			secondImage = product.fourthImage
		} else if ( collection_gender == 'unisex' ) {
			if (i % 2 == 1) {
				firstImage = product.secondImage
				secondImage = product.fourthImage
			}
		}
	}
	
	var $Product = $("<div>", {"class": product_classes, "data-id": product.id, "data-colour": product.colour});
	var $InfoWrap = $("<div>", {"class": "info-wrap"});
	var $InfoLeft = $("<div>", {"class": "info-container"});
	var $InfoRight = $("<div>", {"class": "info-container-right"});
	
	let
		product_flags = '',
		preorder_flag = false,
		flag_count = 0
	if ( product.available ) {
		prod_tag_string = product.tags.join(', ') 
		if ( prod_tag_string.indexOf("available:") > -1) {
			preorder_flag = true
			product_flags = '<span class="product-flag">Pre-order</span>'
		}
		if ( preorder_flag == false ) {
			$.each(product_flags_list, function(i, flag) {
				if ( flag.tag != '' && product.tags.indexOf(flag.tag) > -1) {
					flag_count = flag_count + 1
					product_flags = '<span class="product-flag '+flag.class+' flag-'+flag_count+'">'+flag.title+'</span>'
				}
			});
		} 
	} else {
		if ( product.tags.indexOf("COMINGSOON") > -1) {
			product_flags = '<span class="product-flag">Coming soon</span>'
		} else {
			product_flags = '<span class="product-flag">Sold Out</span>'
		}
	}
	
	var quick_add_options = $("<div>", {"class": "quick-add"});
	/* added this to on click even in cart.js
	$.each(product.variants, function(i, v) {
		let availability = ''
		if ( v.inventory_quantity > 0 ) {
			availability = ' disabled'
		}
		quick_add_options.append('<button type="button" data-id="'+v.id+'"'+availability+'>'+convert_size(product.title,v.title)+'</button>');
	});
	*/
	
	img = '<a class="product-image" href="' + product.url +'"><img loading="lazy" src="'+firstImage+'" data-image2="'+secondImage+'"/>'+product_flags+quick_add_options[0].outerHTML+'<div class="quick-add-btn"><span>+ Quick Add</span></div></a>';
	title = '<a class="title" href="' + product.url + '">' + prodTitle[0] + '</a>';
	subtitle = '<a class="subtitle" href="' + product.url + '">' + prodTitle[1] + '</a>';
	
	var $ProductPrice = $("<a>", {"class": "price", "href": product.url});
	var $ProductSalePrice = $("<a>", {"class": "del-price", "href": product.url});
	 
	if (parseInt(product.price) < parseInt(product.compare_at_price)) {
		$ProductPrice.addClass('reduced')
	} else { 
		$ProductSalePrice.hide();
	}
	
	let salesTag = ''
	if ( product.salesTag != '' ) {
		salesTag = '<p class="percent-discount">'+product.salesTag+'% OFF AT CHECKOUT</p>'
	}
	let salesTagCustom = ''
	if ( product.salesTagCustom != '' ) {
		salesTagCustom = '<p class="sales-tag-custom">'+product.salesTagCustom+'</p>'
	}
	
	$ProductPrice.append( money(product.price) );
	$ProductSalePrice.append( money(product.compare_at_price) );
	
	swatches = $("<div>", {"class": "swatches"}); 
	 
	$InfoLeft.append(title,subtitle,salesTagCustom)
	$InfoRight.append($ProductPrice,$ProductSalePrice,salesTag,swatches)
	$InfoWrap.append($InfoLeft,$InfoRight)
	
	$Product.append(img,$InfoWrap)
	
	container.append($Product) 
}

function filterCollection(collection_url){	
	
	$('#products-grid').before('<div class="loading-collection"><span class="loader delay-2"></span> <span class="loader delay-1"></span> <span class="loader"></span></div>') 
	
	SelectedTypes = []
	SelectedSizes = []
	SelectedPrices = []
	SelectedColours = []
	
	$('#collection-types input:checked').each(function() {
		SelectedTypes.push($(this).val());
	});
	
	$('#collection-sizes input:checked').each(function() {
		SelectedSizes.push($(this).val());
	});
	
	$('#collection-prices input:checked').each(function() {
		newPrice = parseInt($(this).val());		
		SelectedPrices.push(newPrice);
	});
	
	$('#collection-colours input:checked').each(function() {
		SelectedColours.push($(this).val());
	});
	
	SelectedSort = $('#collection-sort input:checked').val();
	
	//console.log('selected types: '+SelectedTypes )
	//console.log('selected sizes: '+SelectedSizes )
	//console.log('searching:/collections/'+collection_url+'?view=json'+SelectedSort,)
	
	$.ajax({
		url:	'/collections/'+collection_url+'?view=json'+SelectedSort,
		type:	'GET'
	})
	.done(function(data) {
		//console.log($.parseJSON(data));
		$('.product-grid').not(':first').remove();
		$('#products-grid').empty();
		
	  
		$.each(JSON.parse(data).results, function(i, item) {	
			
			$('.loading-collection').remove();		
			match = false
			
			if (typeof item.title !== 'undefined') {
				match = true				
			}
			
			if (SelectedTypes.length !== 0) {
				if (match == true) {
					if (typeof item.filterType !== 'undefined') {
						match = false
						productType = item.filterType
						productType = productType.replace(/\ /g,'-').toLowerCase().split(',');
							
						if ( SelectedTypes.some(v=> productType.indexOf(v) !== -1) ) {	
							match = true		
						}
					}
				}
			}
			
			
			if (SelectedSizes.length !== 0) {
				if (match == true) {
					if (typeof item.sizes !== 'undefined') {
						match = false
						productSizes = item.sizes
						productSizes = productSizes.split(',');
		
						if ( SelectedSizes.some(v=> productSizes.indexOf(v) !== -1) ) {
							match = true						
						}
					}
				}
			}
			
			if (SelectedPrices.length !== 0) {
				if (match == true) {
					if (typeof item.priceFilterIndex !== 'undefined') {
						match = false
						productPrice = item.priceFilterIndex
		
						if ( (SelectedPrices.indexOf(productPrice) > -1) ) {
							match = true						
						}
					}
				}
			}
			
			if (SelectedColours.length !== 0) {
				if (match == true) {
					if (typeof item.filterColour !== 'undefined') {
						match = false
						productColour = item.filterColour
						productSizes = productColour.split(',');
							
						if ( SelectedColours.some(v=> productColour.indexOf(v) !== -1) ) {	
							match = true		
						}
					}
				}
			}
			
			if (match == true) {
				//console.log('title: '+item.type)			
				AddProduct(i, item, desktop_view, $('#products-grid'));		
			}		
		});
		
		//Load all of the nice collection functions
		SecondImageRollovers.initRollovers();
		$(loadCollectionSwatches(collection_url));
		QuickView();
	});
}

$(document).on("change", "#collection-filters input", function () {
	var collection_url = $('#products-grid').data('handle');
	$(filterCollection($('.product-grid').data('handle')));
});
	
function CollectionLandingNav(){
	$('.nav-images a').click(function(){
		if ($(window).width() < screen_small) {
			offset = -100
		} else {
			offset = -30
		}
		$('html, body').animate({
			scrollTop: $($.attr(this, 'href')).offset().top + offset
		}, 1000);
	});
}

function updateView(){
	if (desktop_view == 'large--one-half') {
		$('.product-item').each(function() {
			img_width = $(this).data('width');
			this_img = $(this).find('.product-image img');
			this_img.attr('src',this_img.attr('src').replace('_'+img_width,'_1000x'));
			this_img.data('image2',this_img.attr('data-image2').replace('_'+img_width,'_1000x'));
			$(this).removeClass('large--one-quarter');
			$(this).addClass('large--one-half');
		});
	} else {
		$('.product-item').each(function() {
			$(this).removeClass('large--one-half');
			$(this).addClass('large--one-quarter');
		});
	}
}
$('.view-options button').click(function(){
	$('.view-options button').removeClass('active');
	$(this).addClass('active');
	desktop_view = $(this).attr('data')
	updateView()
});


let pInfScrLoading = false;
let pInfScrDelay = 100;
let loadingCollection = false;
let pInfScrNode = $('.more').last();	
let pInfScrURL = $('.more a').last().attr("href");
	
function pInfScrExecute() {
	var loadingImage;
	loadingCollection = true;
	pInfScrNode = $('.more').last();	
	pInfScrURL = $('.more a').last().attr("href");
	
	console.log( pInfScrURL );
	if (!pInfScrLoading && pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none' && typeof(pInfScrURL) != 'undefined' ) {
		$.ajax({
			type: 'GET',
			url: pInfScrURL,
			beforeSend: function() {
				pInfScrLoading = true;
				loadingImage = pInfScrNode.clone().empty().append('<img src="https://cdn.shopify.com/s/files/1/0497/8277/files/loader.gif?v=1618948654" />');
				loadingImage.insertAfter(pInfScrNode); 
				pInfScrNode.remove(); 
			},
			success: function(data) {
				// remove loading feedback
				
				pInfScrNode.next().remove();
				var filteredData = $(data).find(".collection-matrix");
				filteredData.insertBefore( $("#product-list-foot") );
				
				//Move new products into the existing collection-matrix div - handy for when we are hiding new arrivals
				newProducts = $("#collection-page .collection-matrix").last().html();
				$("#collection-page .collection-matrix").last().remove();
				$('.collection-matrix').append(newProducts);
				
				loadingImage.remove();
				pInfScrLoading = false;
							
				//Load all of the nice collection functions
				updateView();
				SecondImageRollovers.initRollovers();
				$(loadCollectionSwatches($('#products-grid').data('handle')));
				setTimeout(function(){ loadingCollection = false }, 1500);		
				
				/*
				if( load_more == true ) {
					pInfScrExecute();
				}*/			
			},
			dataType: "html"
		});
	}
}

//Collection infinity scrolling
if (document.querySelector('.more') !== null) {
	
	$(window).scroll(function(){
		//console.log( pInfScrURL ) 
		
		function elementScrolled(elem){
			var docViewTop = $(window).scrollTop();
			var docViewBottom = docViewTop + $(window).height() + 400;
			var elemTop = $(elem).offset().top;
			return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
		}

		if ($('.more').length) {
			if (elementScrolled('.more')) {	
				if (loadingCollection == false) {	
					pInfScrExecute();
				}
			}
		}
	});
	
	$('.more a').click(function(e){
		e.preventDefault();
		pInfScrExecute();
	});
	
	//Not sure what this does
	/*
	if (typeof load_more !== 'undefined') {
		if ( load_more == true ) {
			pInfScrExecute();
		}
	}
	*/
}

function filter_action(form_url){
	$('#filter-loader span').addClass('loading');
	
	history.pushState({},"Filter Results",form_url)
	
	fetch(form_url)
	.then(response => response.text())
	.then(html => {
		//console.log( html )
		var parser = new DOMParser();
		var pageHTML = parser.parseFromString(html, 'text/html');

		const active_filters_new = pageHTML.getElementById('active-filters');	
		const active_filters = document.getElementById('active-filters');	
		active_filters.innerHTML = active_filters_new.innerHTML;
		
		const filters_tags_new = pageHTML.getElementById('filters-tags');	
		const filters_tags = document.getElementById('filters-tags');	
		filters_tags.innerHTML = filters_tags_new.innerHTML; 
		
		const filter_type_new = pageHTML.getElementById('filters-product-type');	
		const filter_type = document.getElementById('filters-product-type');	
		filter_type.innerHTML = filter_type_new.innerHTML; 
		
		const filters_colours_new = pageHTML.getElementById('filters-colours');	
		const filters_colours = document.getElementById('filters-colours');	
		filters_colours.innerHTML = filters_colours_new.innerHTML; 
		
		const filters_size_new = pageHTML.getElementById('filters-size');	
		const filters_size = document.getElementById('filters-size');	
		filters_size.innerHTML = filters_size_new.innerHTML; 

		const grid_new = pageHTML.getElementById('products-grid');	
		const grid = document.getElementById('products-grid');	
		grid.innerHTML = grid_new.innerHTML; 
		
		pInfScrNode = $('.more').last();	
		pInfScrURL = $('.more a').last().attr("href");
		
		$('#filter-loader span').removeClass('loading');

	})
	.catch(e => {
		console.error(e);
	});	
}

$('#filter-panel').on('click', '.filter-group label', function(e) {
	//$(this).toggleClass('selected');
	setTimeout(function(){ 
		//slight delay to make sure options have been updated
		checkQueryParams();
		
		const form_data = '?'+$('.filter-form').serialize();
		const sort_order = new URLSearchParams(Shopify.queryParams.sort_by).toString().replace('=','')
		console.log( sort_order )
		const form_url = window.location.pathname+form_data+'&sort_by='+sort_order;
		
		filter_action(form_url)	
	}, 100);		
});

$('#filter-panel').on('click', '.active-filters__remove-filter', function(e) {
	e.preventDefault()

	filter_action($(this).attr('href'))	
});

/* PRODUCT PAGE */ 

function Tab(){
	
	var tabContainer = $(".tab-container");
	if(tabContainer.length < 1) return;
	
	function addTabHeaderEvents(){
		
		tabContainer.each(function(e){
			var container = $(this);
			container.find(".tab-header").click(function(e){
				var selectedTabHeader = $(this);
				var selectedTabContent = container.find("#" + selectedTabHeader.data("tabcontentid"));
				container.find(".tab-header").removeClass("selected");
				container.find(".tab-content").hide();
				selectedTabHeader.addClass("selected");
				selectedTabContent.show();
			});
		});
	}
	
	function addSelectTabEvents(){
		$(".select-tab").click(function(e){
			var selectedTabHeader = $("#" + $(this).data("tabheaderid"));
			var container = selectedTabHeader.closest(".tab-container");
			var selectedTabContent = container.find("#" + selectedTabHeader.data("tabcontentid"));
			container.find(".tab-header").removeClass("selected");
			container.find(".tab-content").hide();
			selectedTabHeader.addClass("selected");
			selectedTabContent.show();
		});
	}
	
	addSelectTabEvents();
	addTabHeaderEvents();
}
function ProductVideoThumbs(){
	$('.product-thumbnails li button').click(function(e){
		$('#product-slideshow').trigger('to.owl.carousel', $(this).data('index'))
	});
}

function ProductColorSwatches() {
	color_count = 0;
	$.ajax({
		url:	"/collections/"+product_collection+"?view=json_swatches",
		type:	'GET'
	})
	.done(function(data) {
		//console.log($.parseJSON(data));
		$.each(JSON.parse(data).results, function(index, item) {
			var current_product = ""
			if ( item.colour == product_object.colour ) {
				current_product = " selected" 
			}
			//console.log(product_object.key+'//'+item.key+'+'+item.colour);
			if (product_object.key == item.key && product_object.type == item.type) {
				color_count = color_count + 1;
				//console.log('{{product_key}}//'+item.key + item.colour);
				let colour_handle = item.colour.replace(' ','-');
				$('.product_form .swatches.colour-swatches').append('<a href="/collections/'+product_collection+'/products/'+item.handle+'" data="'+item.colour+'" class="'+current_product+'" title="'+item.colour+'"><img src="'+item.image+'" width="48" height="67" alt="'+item.title+' swatch"/></a>');
			}
		});
		
		if ( color_count == 0 ){
			$('.colour-swatches').css('min-height','0px')
		}
	})
	.fail(function(data) {})
	.always(function(data) {});
} 

function variant_reorder(){
	//Reorder Product Variant Sizes - Because Netsuite Messes up the order in Shopify	
				
	var data_type = $('.size-swatches .swatch:first-of-type').data('value');
	var $wrapper = $('.size-swatches');
	if(isNaN(data_type)){
		//we are working with s, m, l etc
		var order = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']; 
		
		$wrapper.find('.swatch').sort(function(a, b) {
			var aSize = $(a).data('value').toLowerCase(), bSize = $(b).data('value').toLowerCase();
			//console.log('asize: '+aSize);
			//console.log('bsize: '+bSize);
			return order.indexOf(aSize) - order.indexOf(bSize);
		}).appendTo($wrapper);
	} else { 
		
		//Were working with numbers eg. 8, 10, 12	
		$wrapper.find('.swatch').sort(function(a, b) {
			return +a.dataset.value - +b.dataset.value;
		})		
		.appendTo($wrapper);
	}	
	
	//Sometime we get duplicates that need to be deleted
	var elem = {};
	$wrapper.find('.swatch').each(function() {		
		var txt = $(this).data('value');
		if (elem[txt])
			$(this).remove();
		else
			elem[txt] = true;
	}); 
}

function checkSwatches(){
	selected_option = $(".product_form select[name=id] option:selected");
	//alert('1:'+selected_option);
	updateLowInStockMessage(selected_option);
	ProductPickup(selected_option);
} 

function productSlideshow(){
	
	var $owl = $("#product-slideshow");
	var owl = $owl.owlCarousel({
		items:1,
		nav:false,
		autoplay:false,
		dots:true,
		loop:true,
		rewind: true,
		lazyLoad: true,
		lazyLoadEager: 1,
		responsive : {
			601 : {
				items:2,
				margin: 7,
				dots:false,
				nav:true,
				mouseDrag: false
			}
		}
	});
	
	owl.on('changed.owl.carousel', function(event) {
		currenct_slide = event.property.value + 1
			
		slide_video = $('.owl-item:nth-of-type('+currenct_slide+')').find('video')
		slide_video_url = slide_video.data('video')
		
		if (typeof slide_video_url !== "undefined") {
			slide_video_url = slide_video.data('video')
			$(slide_video).html('<source src="'+slide_video_url+'" type="video/mp4" />');
			$('#mobile-video').trigger('play');
		}
	})	 
} 

function sizeGuide(){
	//SIZE GUIDE POPUPS
	$('#size-guide-trigger').click(function() { 
		$('.size-guide-popup').fadeIn(); 
	});

	$('#shipping-pop-trigger').click(function() { 
		$('#shipping-guide-popup').fadeIn(); 
	});
	
	$('#product-page .product-flag').click(function() { 
		$('#flag-info-popup').fadeIn(); 
	});

}

function updateLowInStockMessage(selected_option){
	var MIN_LOW_IN_STOCK_NOTICE_LEVEL = 6; 
	var stockLevel = null;
	
	stockLevel = parseInt( selected_option.data("qty") );
		
	if ( stockLevel == 0 ) {
		$("#low-in-stock").hide();
		$('.add_to_cart').hide();
		$('#NotifyMe').show();
	}
	else if ( stockLevel < 0 ) {
		$("#low-in-stock").hide();
		$('.add_to_cart').show();
		$('#NotifyMe').hide();
	}
	else if (stockLevel === null || stockLevel === undefined || stockLevel > MIN_LOW_IN_STOCK_NOTICE_LEVEL) {
		$("#low-in-stock").hide();
		$('.add_to_cart').show();
		$('#NotifyMe').hide();
	}
	else { 
		$("#low-in-stock").show();
		$('.add_to_cart').show();
		$('#NotifyMe').hide();
	}
	
	let price = selected_option.data("price")
	let compare = selected_option.data("compare")
	
	//alert( price )
	
	$('#ProductPrice').html(money(price)); 
	
	if (typeof compare !== "undefined" && compare > price) {
		$('#ComparePrice').show();
		$('#ComparePrice').html(money(compare));
	} else { 
		$('#ComparePrice').hide();
	}
}

/*
$('body').on('change', '.size-swatches .swatch :radio', function(){
	updateLowInStockMessage();
	ProductPickup();
});
*/

$('.swatch input:radio').change(function() {	
	opt_1 = $(".swatch input[name=option-1]:checked").val();
	opt_2 = $(".swatch input[name=option-2]:checked").val();
		
	//alert( opt_1 )
	//alert( opt_2 )
	
	let selected_option = $(".product_form select[name=id] option[data-opt-1='"+opt_1+"']")
	let selected_option_sticky = $("#sticky-add-to-cart option[data-opt-1='"+opt_1+"']")
	
	if (typeof opt_2 !== "undefined") {
		selected_option = $(".product_form select[name=id] option[data-opt-1='"+opt_1+"'][data-opt-2='"+opt_2+"']")
		selected_option_sticky = $("#sticky-add-to-cart option[data-opt-1='"+opt_1+"'][data-opt-2='"+opt_2+"']")
	}
	selected_option.prop('selected', true)
	selected_option_sticky.prop('selected', true)
	//alert('2:'+selected_option);
	
	updateLowInStockMessage(selected_option);
	ProductPickup(selected_option);
});


function thumbNav(){
	scrollPos = 0
	
	var $thumbs =  $('.product-thumbnails li')
	if ( $thumbs.length < 6 ) {
		$('.thumb-nav.down').hide()
	}
	
	wrap = $('.product-thumbnails .wrap')
	
	setTimeout(function(){
		slidershowHeight = $('#product-slideshow').outerHeight()
		navHeight = $('.product-thumbnails .wrap').outerHeight() - slidershowHeight

		wrap.css('height', slidershowHeight )

	}, 1000);
	
	$('.thumb-nav.down').click(function(){
		
		scrollPos = scrollPos + slidershowHeight
		wrap.animate({scrollTop: '+'+slidershowHeight}, 800);
		
		$('.thumb-nav.up').fadeIn()
		
		if ( scrollPos > navHeight ) {
			$('.thumb-nav.down').fadeOut()
		}
		
	})
	
	$('.thumb-nav.up').click(function(){
		scrollPos = scrollPos - slidershowHeight
		wrap.animate({scrollTop: '+'+scrollPos}, 800);
				
		if ( scrollPos > navHeight ) {
			$('.thumb-nav.down').fadeOut()
		} else {
			$('.thumb-nav.down').fadeIn()			
		}
		
		if ( scrollPos <= 0 ) {
			$('.thumb-nav.up').fadeOut()
		}
	})
}

function ProductFunctions(){
	if ($('.product-thumbnails .wrap.cropped').length) {
		thumbNav()
	}
}

function ProductOutOfStock(){
	$('#NotifyMe').click(function(){
		$('#out-of-stock').fadeIn(); 
	});

	$('#out-of-stock form').submit(function(e) {
		e.preventDefault();
		subscribe_for_newsletter = false
		if ($('#oof-subscribe input').is(':checked')) {
			subscribe_for_newsletter = true
		}
				
		e.preventDefault();
		$.ajax({
			type: "POST",
			url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
			data: {
				a: klaviyo_key,
				email: $('#out-of-stock input[type=email]').val(), 
				variant: $(".product_form select[name=id] option:selected").val(),
				product: $('.product_form').data('id'),
				platform: "shopify",
				subscribe_for_newsletter: subscribe_for_newsletter,
				g: klaviyo_list,
			},
			success: function(response){
				console.log(response)
				$('#out-of-stock .btn').after("<p class='success'>Success! We'll let you know when it's back.</p>")
			}
		});
	});
}

function ProductPickup(selected_option){
	selected_variant = selected_option.val();
	
	fetch('/variants/'+selected_variant+'/?section_id=pickup-availability')
	.then(response => response.text())
	.then(text => {
		const container = document.querySelector('[data-store-availability-container]');
		const pickupAvailabilityHTML = new DOMParser()
		.parseFromString(text, 'text/html')
		.querySelector('.shopify-section');
		
		if ( container != null ) {
			container.innerHTML = pickupAvailabilityHTML.innerHTML;
		}
	})
	.catch(e => {
		console.error(e);
	});
	
	$('body').on('click', '.pickup-availability-information__button', function() {
		$('.pickup-availabilities-modal').addClass('active');
	});
	
	$('body').on('click', '.pickup-availabilities-modal__close', function() {
		$('.pickup-availabilities-modal').removeClass('active');
	});
} 



const
	eu_countries = 'at be bg hr ch cy cz dk ee fi fr de gb gr hu ie it lv lt lu mt nl pl pt ro sk si es se',
	au_countries = 'au hk sg nz',
	us_countries = 'ca us jp';

var region_param = queryUrlParams.region;


if (typeof region_param != 'undefined') {
	setCookie("geo_location_v3", region_param, 365); 
}

function storeSelection(region, new_currency) {
	
	//console.log(store_location + ' / ' + region + ' / ' + new_currency)
	
	setCookie("geo_location_v3", region, 365);  
		
	if ( store_location == region ) { 
		//console.log( 'change currency?');
		//Same region, close popup
		$('#store-select-popup, #store-update-popup').fadeOut()
				
		//Still need to check currency though
		if ( (new_currency != cart_currency) && (typeof new_currency != 'undefined')) { 					
			changeCurrency(new_currency)
		} 
	} else {
		let customer_cart = [];
		function cart_items(data){
			data.items.forEach(function(item) {
				item = {
					'handle': item.handle,
					'variant': item.variant_title,
					'qty': item.quantity
				}
				customer_cart.push(item);
			});
			
			setCookie("customer_cart", JSON.stringify(customer_cart), 1);
			
			if ( region == 'au' ) {
				new_url = 'https://afends.com'
			} else {
				new_url = 'https://'+region+'.afends.com'
			}
			
			window.top.location.href = new_url + pathname.split('?')[0] + '?currency='+ new_currency + '&region='+ region
		}
		
		//Get customer's cart and then redirect
		fetch('/cart.js')
		  .then(response => response.json())
		  .then(data => cart_items(data) );		
	}
}

region = getCookie("geo_location_v3")
if (region != "") { 
	// If customer has selected a store we might redirect
	storeSelection(region); 
} else {
	//Else Display Store Selector Popup if no store has previously been set
	var request = new XMLHttpRequest();
	request.onreadystatechange = function() {
		
		//setCookie("geo_location_v3", store_location, 365); 
		
		if (request.readyState === 4 && request.status === 200) {
			json = JSON.parse(request.responseText)
			
			current_country = json['location']['country']['code'].toLowerCase()
			//current_region = json['location']['region']['code'].toLowerCase()

			console.log(store_location + ' / ' + current_country)

			free_shipping_val = '$150 AUD'
			
			if (au_countries.indexOf(current_country) >= 0) {
				region = 'au'; 
				region_currency = 'AUD'; 
				free_shipping_val = '$80 AUD'
			} else if (eu_countries.indexOf(current_country) >= 0) {
				region = 'eu';
				region_currency = 'EUR'; 
				free_shipping_val = '€50'
			} else if (us_countries.indexOf(current_country) >= 0) { 
				region = 'us';
				region_currency = 'USD'; 
				free_shipping_val = '$50 USD'
			} else  {
				region = 'au';
			} 
			
			//setCookie("geo_location_v3", region, 365); 

			console.log( store_location + '/' + region + '/' + region_currency);

			if ( store_location != region ) {
				if ( window.location.pathname == '/pages/bio-link') {
					//if instagram bio link lets auto redirect and save cookie
					setCookie("geo_location_v3", region, 365); 
					storeSelection(region); 
				} else {
					$('#freeShippingValue').html(free_shipping_val)
					$('#customerLocation').html(json['location']['country']['name']+'.')
					$('#confirm-location').data('region',region);
					$('#confirm-location').data('currency',region_currency);
					if (tapcart != true){
						$('#store-select-popup').fadeIn();
					}
				}
			}
		}
	}; 
	setTimeout(function(){
		//delay for a few seconds so we don't impact page speed
		request.open('GET', 'https://api.ipregistry.co/?key=t974nbyc1tm97q', true);
		//TESTrequest.open('GET', 'https://api.ipregistry.co/?key=m7yuucusvownpf47', true); 
		request.send(null);
		//setCookie("geo_location_v3-viewed", 'yes', 365);
		//setCookie("location-checked", 'yes', 365);
	}, 3000);
}

//GEO IP 1st Popup
$('.store-selector').on('click', function(e) {
	e.preventDefault(); 
	region = $(this).data('region');
	region_currency = $(this).data('currency');
	//setCookie("geo_location_v3", region, 365); 
	storeSelection(region,region_currency);
}); 

//The Popup 
$('#new-location').submit(function(e) {
	e.preventDefault(); 
	region = $(this).find(':selected').val()
	new_currency = $(this).find(':selected').data('currency')	
	//setCookie("geo_location_v3", region, 365); 
	setCookie("currency", new_currency, 1); 
	
	console.log('redirect')
	storeSelection(region, new_currency);
});  

$('#change-location').click(function(){
	$('#store-select-popup').fadeOut()
	$('#store-update-popup').fadeIn()
});

$('.store-list').click(function(event) {
	event.preventDefault();
	$('#store-update-popup').fadeIn();
});

//Post Redirect add customers products to cart
let unavailable_products = [];
if (getCookie("customer_cart") != "") { 
	customer_cart_cookie = JSON.parse(getCookie("customer_cart"));

	console.log(customer_cart_cookie)
	if ( customer_cart_cookie.length != 0 ) {

	console.log('not zero')
		
		if ( window.location.pathname == '/cart') {
			$('html').append('<div id="loading-checkout"><p>Loading your cart</p></div>' );
		} 
		
		//First empty cart
		$.ajax({
			type: "POST",
			url: '/cart/clear.js',
			data: '',
			dataType: 'json',
			success: function() { 
				Shopify.moveAlong = function() {
					if (customer_cart_cookie.length) {
						var request = customer_cart_cookie.shift();
						//console.log(request)
						let variant_found = false;
						
						jQuery.getJSON('/products/' + request.handle + '.js', function (product) {
							$.each(product.variants, function(i, variant) {
								if ( variant.title == request.variant ) {
									variant_found = true;
									dataObj = {        
										quantity: request.qty, 
										id: variant.id,
									};
									//console.log(dataObj)
									$.ajax({
										type: 'POST',
										url: '/cart/add.js',
										dataType: 'json',
										data: dataObj,
										success: function(res){
											Shopify.moveAlong();
										},
										error: function(error){
											console.log(error);
											console.log("error: " + request);
											Shopify.moveAlong()
										}
									});
								} 
							});
						})
						.done(function(product) {
						})
						.fail(function(data) {})
						.always(function(data) {
							if ( variant_found == false ) {
								//No match? No worries, log it and move on
								item_title = request.handle
								item_title = item_title.replace('afends','').replace('womens','').replace('mens','').replaceAll('-', ' ')
								item = {
									'title': request.handle,
									'qty': request.qty
								}
								unavailable_products.push(item);
								console.log('cant find: '+item_title)
								Shopify.moveAlong()
							}
						});
					}
					else {						
						setCookie("customer_cart", "", 0.1);
						//for some reason cart delete anymore?
						document.cookie = 'customer_cart' + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=.afends.com; path=/';
						document.cookie = 'customer_cart' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT; domain=afends.com; path=/';
						
						setCookie("customer_cart_unavailable", JSON.stringify(unavailable_products), 1);
						if ( window.location.pathname == '/cart') {
							location.reload();
						} else {
							//ajaxCart.load();
							build_cart();
						}
					}
				};
				Shopify.moveAlong();
			}
		});	
	}
} 

const cust_cart_unavailable = getCookie("customer_cart_unavailable")
if ( cust_cart_unavailable != "" && cust_cart_unavailable != '[]' ) { 
	cart_unavailable = JSON.parse(cust_cart_unavailable);
	
	let alert_message = "The following products aren't available on this store: ";
	
	$.each(cart_unavailable, function(i, product) {
		alert_message = alert_message + ', ' + product.title + ' - ' + product.variant + ' x ' + product.qty
	});
	
	setCookie("customer_cart_unavailable", "", 0.1);
	document.cookie = 'customer_cart_unavailable' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT; domain=.afends.com; path=/';
	document.cookie = 'customer_cart_unavailable' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT; domain=afends.com; path=/';
	
	/*
	console.log(alert_message)
	$(html).append(`
		<div id="newsletter-popup" class="popup-wrapper">
			<div class="popup-inner">
				<button type="button" class="close-popup" aria-label="close popup">×</button> 
		
				<div class="step-1">
					<p><span>{{ section.settings.step_1 }}</span></p>
				</div>
		
				<div class="popup-container text-center">
					<div class="popup-content">
						<h4>Products unavailable</p>
						<p>The following product are unavailabile on this store:</p>
						<p>`+alert_message+`</p>
				
					</div>
				</div> 
			</div>
		</div>
	`);
	*/
}



/*
$(function ajax_search() {
	
	// Current Ajax request.
	var currentAjaxRequest = null;
	// Grabbing all search forms on the page, and adding a .search-results list to each.
	var searchForms = $('#search-popup form[action="/search"], #mobile-search form[action="/search"]').css('position','relative').each(function() {
		// Grabbing text input.
		var input = $(this).find('input[name="q"]');
		// Adding a list for showing search results.
		var offSet = input.innerHeight();
		$('<ul class="search-results"></ul>').css( { 'position': 'absolute', 'left': '0px', 'top': offSet } ).appendTo($(this)).hide(); 	   
		// Listening to keyup and change on the text field within these search forms.
		input.attr('autocomplete', 'off').bind('keyup change', function() {
			// What's the search term?
			var term = $(this).val(); 
			// What's the search form?
			var form = $(this).closest('form');
			// What's the search URL?
			//Exclude unavailable products
			var searchURL = '/search?type=product&options[unavailable_products]=hide&q=' + term;
			// What's the search results list?
						
			var resultsList = form.find('.search-results');
			// If that's a new term and it contains at least 3 characters.
			if (term.length > 2 && term != $(this).attr('data-old-term')) {
				// Saving old query.
				$(this).attr('data-old-term', term);
				// Killing any Ajax request that's currently being processed.
				if (currentAjaxRequest != null) currentAjaxRequest.abort();
				// Pulling results.
				currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
					// Reset results.
					resultsList.empty();
					// If we have no results.
					if(data.results_count == 0) {
						// resultsList.html('<li><span class="title">No results.</span></li>');
						// resultsList.fadeIn(200);  
						resultsList.hide();
		
						//Search status messages
						$('#searching-animation').fadeOut('fast');
						$('#no-results').fadeIn('fast');
						console.log('no results');
		
		
					} else {
						// If we have results.
						ga('send', 'event', {
								eventCategory: 'Actions',
								eventAction: term,
								eventLabel: 'Search'
						}); 
		  
						//Search status messages
						$('#searching-animation').fadeOut('fast');
						$('#no-results').fadeIn('fast');
						console.log('results found');
		  
						//Add a nice heading
						resultsList.append('<li class="results-heading"><h6>Top Results</h6></li>');    
		  
						var availableResults = 0
		  
						$.each(data.results, function(index, product) {
			  
							//console.log(item.url+' price: '+item.price_clean+'sale: '+item.compare_at_price_clean);
							if (
								($.isEmptyObject(product)) || 
								(product.title == 'Thank You Card' ) ||
								(product.title == 'Australia Post Return Postage Label' ) ||
								(product.title == 'USPS Pre' )) {
								// If product is free, sold out or returns shipping label please skip - the free product testing isnt tested
							} else {
								prodTitle = product.title.replace('Afends','').replace('Unisex','').replace('Mens','').replace('Womens','').split(' - ') 
								
								//console.log(itemAvailability);
								var link = $('<a></a>').attr('href', product.url);
								link.append('<div class="thumbnail"><img src="' + product.firstImage + '" /></div>');
								link.append('<h4 class="title">' + prodTitle[0] + '</h4>');
								link.append('<p class="subtitle">' + prodTitle[1] + '</p>');
								
								price = Math.round(product.price/currency_division);
								comparePrice = Math.round(product.compare_at_price/currency_division);
								price =  '<span class="money">'+ currency_symbol + price + ' '+store_currency+'</span>';
								comparePrice =  '<span class="money">'+ currency_symbol + comparePrice + ' '+store_currency+'</span>';
								
								if ( product.price < product.compare_at_price ) {
									link.append('<p class="price reduced">' + price + ' <s>' + comparePrice + '</span></p>');
									link.wrap('<li class="on_sale"></li>');
								} else {
									link.append('<p class="price">' + price +'</p>');
									link.wrap('<li></li>');
								}
				  
								availableResults = availableResults + 1
								resultsList.append(link.parent());
							}
						});

						//move on sale products to the bottom of the list
						//$('.search-results').find('li.on_sale').appendTo('.search-results');
		  
						// The Ajax request will return at the most 10 results.
						// If there are more than 10, let's link to the search results page.			  
						if(data.results_count > 10) {
							resultsList.append('<li class="view-all-results"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></li>');
						}
						resultsList.fadeIn(200);
		
						if (availableResults == 0) {
							$('.results-heading').slideUp('fast');
							$('#no-results').slideDown('fast');
			
						} else {
							$('.results-heading').slideDown('fast');
							$('#no-results').slideUp('fast');
						}
					}    		      
				});
			}
		});
	});
});	

if (typeof search_term !== 'undefined') {
	//Search url for products only and excluding unavailable products
	var searchURL = '/search?type=product&options[unavailable_products]=hide&q=' + search_term;
	$('#search-page #searching-animation, #search-animation-bar').fadeIn('fast');
			
	// Pulling results.
	$.getJSON(searchURL + '&view=json', function(data) {
			
		// If we have no results.
		if (data.results_count == 0) {
					
			console.log('no results');
			$('.results-heading').slideDown('fast');
			$('#no-results').slideUp('fast');
	
		} else {
			// If we have results.
			ga('send', 'event', {
				eventCategory: 'Actions',
				eventAction: search_term,
				eventLabel: 'Search'
			}); 
	  
			//Search status messages
			$('#search-page #searching-animation, #search-animation-bar').fadeOut('fast');
	  	  
			$.each(data.results, function(index, product) {		  
				var itemAvailability = "available"
		  
				if (
					($.isEmptyObject(product)) || 
					(itemAvailability == 'soldout' ) || 
					(product.title == 'Thank You Card' ) ||
					(product.title == 'Australia Post Return Postage Label' ) ||
					(product.title == 'USPS Pre' )) {
						// If product is free, sold out or returns shipping label please skip - the free product testing isnt tested
				} else {
					//console.log(itemAvailability);
					AddProduct(product, desktop_view, $('#products-grid'));
				}
			});
						
			//Load all of the nice collection functions
			SecondImageRollovers.initRollovers();
			$(loadCollectionSwatches('all'));
			QuickView();
		}
	});   		      
}

function searchFunctions(){
	//display search popup
	$('#site-header .search, #mobile-search').click(function() {
		$('#search-input').focus();
		
		if ($(window).width() > screen_large) {
			$('#search-popup').slideDown();
		}		
	});
  
	//hide search popup
	$('#search-popup, #search-close').click(function() { 
		$('#search-popup').fadeOut(); 
	});

	// stop hide click on form
	$('#search-popup form').click(function(e) { 
		e.stopPropagation();
	}); 
  
	//remove default saved value so we get the nice 'what are you looking for?' text
	$('#search-popup .search input[type="text"]').val("");

	function not_searching() {
		$('#popular-search-terms, .search-results').fadein('fast');
		$('#searching-animation, #no-results').fadeOut('fast');
	}
	function searching() {
		$('#popular-search-terms, #no-results, .search-results').fadeOut('fast');
		$('#searching-animation').fadeIn('fast');		  
	}

	//hide popular search terms during search
	$('.search input[type="text"]').on('keyup touchend', function(){
		if( !$(this).val() ) {
			not_searching();
		} else {
			searching();
		}
	});
  
	//search by popular search term
	$('#popular-search-terms li').click(function() {
		searching(); 
		var search_term = $(this).html();
		$('#search-popup .search input[type="text"]').val(search_term).trigger('change');
		$('#popular-search-terms').slideUp('slow');
	});

	$('#search-popup form').on('keyup keypress', function(e) {
		var keyCode = e.keyCode || e.which;
		if (keyCode === 13) { 
			e.preventDefault();
			$("#mobile-search #search-input").blur();
			return false;
		}
	});
}*/


$('#site-header .search').click(function() {
	$('#site-header .header-search').addClass('open');	
});

$('#topbar-mobile .search').click(function() {
	$('#search-dropdown').css('top', $('#topbar-mobile').outerHeight() + 'px');	
});

$('#search-dropdown .close').click(function() {
	$('#search-dropdown').css('top', '-100px');	
});

var updated_snizes = false
var updated_popup_snizes = false

function snize_updater(){	
	if ( updated_snizes == false ) {
		updated_snizes = true		
				
		$('.snize-title:not(.updated, .subtitle)').each(function( index ) {
			var snize_product_title = $(this).text().replace('Afends ','').split(' - ');			
			$(this).text( snize_product_title[0] ) 
			$(this).after('<span class="snize-title subtitle">'+snize_product_title[1]+'</span>')
			$(this).addClass('updated')
		});
		
		setTimeout(function() {
			updated_snizes = false	
		}, 1000);
	}
}

$('body').on('DOMSubtreeModified', '.snize-search-results-main-content', function(){
	snize_updater()
});

$(window).on('resize', function(){
	setTimeout(function() {
		snize_updater()
	}, 1000);
});


$('body').on('DOMSubtreeModified', '.snize-ac-results-content', function(){

	if ( updated_popup_snizes == false ) {
		updated_popup_snizes = true		
		
		$('.snize-ac-results .snize-product').hide()
		
		setTimeout(function() {
			console.log('changed')
		
			$('.snize-ac-results-content .snize-title:not(.updated, .subtitle)').each(function( index ) {
				var snize_product_title = $(this).text().replace('Afends ','');			
				$(this).text( snize_product_title ) 
				$(this).addClass('updated')
				
				$('.snize-ac-results .snize-product').fadeIn()
			});
	
			setTimeout(function() {
				updated_popup_snizes = false	
			}, 1000);
		}, 1000);
	}
});


var viewed_products = getCookie("viewed-products");	
var recently_viewed = []

//console.log(viewed_products)
function browsingHistory() {
	if (typeof product_object !== 'undefined') {
		//If we are on a product page
	
		if (viewed_products != "") {
			
			if (typeof viewed_products != 'object') {
				//If we have a string				
				viewed_products = JSON.parse(viewed_products)			
			}
			
			//Avoid duplicates
			contains_product = false			
			$(viewed_products).each(function( index, product ) {
				if ( product.handle == product_object.handle) {
					contains_product = true
				}
			});
				
			//Merge with exisitng cookie
			if ( contains_product == false ) {	
				viewed_products.push(product_object)
				
				setCookie('viewed-products', JSON.stringify(viewed_products), 1);
			}
		
		} else {
			//Create new cookie
			recently_viewed.push(product_object)
			setCookie('viewed-products', JSON.stringify(recently_viewed), 1);
		}
	}
}	
browsingHistory()

function addPromoProduct(product,slider) {
	//Create the product object
	productId = 'product-'+product.id
	prodTitle = product.title
	prodTitle = prodTitle.replace('Afends','').replace('Unisex','').replace('Mens','').replace('Womens','')
	prodTitle = prodTitle.split(' - ') 

	product_classes = 'product-item'

	var $Product = $("<div>", {"class": product_classes, "data-id": product.id, "data-colour": product.colour});
	var $ProductInfo = $("<div>", {"class": "info-container"});

	img = '<a class="product-image" href="' + product.url +'"><img src="'+product.images[0]+'"/></a>';
	title = '<a class="title" href="' + product.url + '">' + prodTitle[0] + ' - ' +  prodTitle[1] + '</a>';
	subtitle = '<a class="subtitle" href="' + product.url + '">' + prodTitle[2] + '</a>';

	var $ProductPrice = $("<span>", {"class": "price"});
	var $ProductSalePrice = $("<span>", {"class": "del-price"});

	if (parseInt(product.price) < parseInt(product.compare_at_price)) {
		$ProductPrice.addClass('reduced')
	} else { 
		$ProductSalePrice.hide();
	}

	$ProductPrice.append( money(product.price) );
	$ProductSalePrice.append( money(product.compare_at_price) );


	var $ProductForm = $("<form>", {"class": "AddToCartForm", "method": "post", "action": "/cart/add"});

	if ( product.variants.length == 1 ){ 
		variant = product.variants[0]

		var_input = '<input type="hidden" name="id" value="'+variant.id+'" />'
		var cta_button = '<input type="submit" value="Add To Cart" class="btn AddToCart" />'

		if ( variant.available != true ) {
			cta_button = '<input type="submit" value="Sold Out" class="btn" disabled />'
		}

		$ProductForm.append(var_input, cta_button)

	} else {

		var $label = '<label for="id-'+product.id+'">Add To Cart</label>'; 
		var $select = $("<select>", {'name': 'id', 'id': 'id-'+product.id});
		//var cta_button = '<input type="submit" value="Add" class="btn small" />'

		$select.append('<option>Add To Cart</option>')

		$(product.variants).each(function (i, variant) {
			if (variant.available){		
				$select.append('<option data-sku="'+variant.sku+'" value="'+variant.id+'">'+variant.title+'</option>')
			} else {
				$select.append('<option disabled="disabled">'+variant.title+' - Sold Out</option>');
			}
		});

		$ProductForm.append($label, $select)
	}


	$ProductInfo.append(title,subtitle,$ProductPrice,$ProductSalePrice)

	$Product.append(img,$ProductInfo,$ProductForm)

	slider.append($Product) 
}

function buildUpsell(recommend_products){	
	
	//console.log(recommend_products)
	
	//Reorder by cheapest
	recommend_products.sort(function(a, b) {
		return parseFloat(a.price) - parseFloat(b.price);
	});
	
	//Need to queue the ajax calls to keep the price order correct
	Shopify.queue = recommend_products;

	Shopify.moveAlong = function() {
		if (Shopify.queue.length) {
				
			var product = Shopify.queue.shift();
						
			if (found_products != limit) {
				if ( ( cartProducts.indexOf(product.handle) === -1 ) && ( freeCartProducts.indexOf(product.handle) === -1 ) ) {					
					found_products = found_products + 1
		
					jQuery.getJSON('/products/' + product.handle + '.js', function (product) {
						addPromoProduct(product,$('#cart-upsell'))						
					})
					.always(function(data) {
						//added to popup, next one please
						Shopify.moveAlong();
					});	
				} else {
					//already in cart, move along
					Shopify.moveAlong();
				}
			} else {
				//at our limit, move along
				Shopify.moveAlong();
			}
		
		} else {
			$('#cart-upsell').owlCarousel({
				loop:false,
				margin:50, 
				dots:false,
				stagePadding: 90,
				responsive:{
					0:{
						items:2,
						margin:20,
						stagePadding: 50,
						nav:false
					},
					600:{
						items:2,
						margin:50,
						stagePadding: 90,
						nav:false
					},
					1000:{
						items:2,
						nav:true
					}
				}
			});
		
			$('#cart-promo-popup').addClass('active')
		
		}
	}		
	Shopify.moveAlong();
}

if (typeof cartDifference !== 'undefined') {
	//If we are on cart page
	var found_products = 0
	var limit = 8
	
	if ( cartDifference > 0 ) {
		//We're building the upsell
		target_price = parseInt(cartDifference) + 3000
		
		if ( ( viewed_products != '' ) && (typeof viewed_products !== 'undefined') ) {
			var recommend_products = JSON.parse( viewed_products )	
		} else {
			//if no viewed products just reset as an empty array for the next .length query
			recommend_products = []
		}
						
		if (recommend_products.length < 8 ) {
						
			//If customer has viewed less than 8 products, add 4 more from Shopify's API
			jQuery.getJSON('/recommendations/products.json?product_id='+cart_item_id+'&limit=8', function(response) {
				$.each(response.products, function(index, product) {
					//Check if recomendation is already a viewed product
					if ( viewed_products.indexOf(product.handle) === -1 ) {
						//create product object and then add to 'recommend_products'
						var recomendation_to_add = {
							"handle":product.handle.toString(),
							"price":product.price.toString()
						} 
						recommend_products.push(recomendation_to_add)
					}
				});				 
			})
			.always(function(data) {
				buildUpsell(recommend_products)
			});	
		} else {
			buildUpsell(recommend_products)
		}
	}
}

$("#cart-upsell").on("mouseenter", "#cart-upsell label", function(e) {
	//Improves niggly tap missfire when another add to cart label is already selected
	e.preventDefault();
	$(this).trigger('click');
});

$('#cart-upsell').on('change', 'select', function(e) {
	$(this).closest('form').submit()
});	

$('#cart-upsell').on('submit', 'form', function(e) {
	e.preventDefault();
	var $form = $(this);
	
	$.ajax({
		url: '/cart/add.js', 
		dataType: 'json',
		type: 'post',
		data: $form.serialize(),
		success: function(itemData) { 
			console.log('success');
			$form.find('.btn').val('added').addClass('green')
			$('#cart-promo-popup .proceed').addClass('show')
			$('#cart-promo-popup .no-thanks').fadeOut()
		}, 
		error: function(XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
			console.log("Error: " + response);
		}
	});
});

$('#cart-upsell a').click(function(e) {
	e.preventDefault()
	console.log('clicked')
	$(this).closest('.product-item').find('form').submit()
});

function fundraising() {

	if (typeof cause_au !== 'undefined') {
		//If we are on the fundraising page

		function buildFundraiser() { 
			if ( totals_gathered == 3 ) {
				
              	fundraising_total = Math.round(fundraising_total);
				
				percent = 100 / goal
	
				percent = percent * fundraising_total
	
				if ( percent < 30 ) {
					$('#progress-bar .text').addClass('right')
				}
		
				$('#progress-bar .progress').css('width', percent+'%' )
				$('#progress-bar .text').fadeIn()

				$('#current-total').empty().append( fundraising_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ) 
				$('#goal').empty().append('<h3>$'+goal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+' Goal</h3>')
			}
		}

		var fundraising_total = 0
		var totals_gathered = 0 

		$.ajax({
			url: 'https://sharethelove.w3apps.co/api/DonationTotal?cause=' + cause_au + '&shopName=afends.myshopify.com',
			type: 'GET'
		}) .done(function(data) {
			console.log(data.total)	
			fundraising_total = fundraising_total + data.total
			totals_gathered = totals_gathered + 1
			buildFundraiser()
		});	  


		$.ajax({
			url: 'https://sharethelove.w3apps.co/api/DonationTotal?cause=' + cause_us + '&shopName=afendsusa.myshopify.com',
			type: 'GET' 
		})
		.done(function(data) {	
			console.log(data.total)	
			fundraising_total = fundraising_total + data.total
			totals_gathered = totals_gathered + 1
			buildFundraiser()
		});		  

		$.ajax({
			url: 'https://sharethelove.w3apps.co/api/DonationTotal?cause=' + cause_eu + '&shopName=afendseurope.myshopify.com',
			type: 'GET'
		})
		.done(function(data) {	
			console.log(data.total)	
			fundraising_total = fundraising_total + data.total
			totals_gathered = totals_gathered + 1
			buildFundraiser()
		});		   
	}
}

function collectionSlider(){
	$(CollectionSliders).each(function(i, slider) {
	
		$(slider.object).owlCarousel({
			items:4,
			nav:false,
			autoplay:false,
			dots:true,
			smartSpeed: 500,
			margin: 15,
			loop:false,
			autoHeight:true,
			responsive : { 
				// breakpoint from 0 up
				0 : {
					items:2,
					stagePadding: 30,
					dots:false
				},
				// breakpoint from 600 up
				600 : {
					items:2,
					stagePadding: false,
					dots:true
				},
				// breakpoint from 900 up
				900 : {
					items:slider.items,
					dots:true
				}
			}
		});
	});
	
	$('.section-collection.slider li button').click(function(){
		parent_div = $(this).closest('.section-collection')
		parent_div.find('li button').removeClass('active');
		$(this).addClass('active');
		parent_div.find('.slider-wrap').css('visibility','hidden');
		$('#' + $(this).data('trigger') ).css('visibility','visible');
	});
}

function contentCarousel(){
	
  	$(ContentCarousel).each(function(i, slider) {

  		$(slider.object).owlCarousel({
  			items:4,
  			nav:false,
  			autoplay:false,
  			dots:true,
  			smartSpeed: 500,
  			margin: 0,
  			loop:true,
  			autoHeight:true,
  			responsive : { 
  				// breakpoint from 0 up
  				0 : {
  					items:1,
  					stagePadding: 90,
  					dots:false
  				},
  				// breakpoint from 600 up
  				600 : {
  					items:2,
  					stagePadding: false,
  					dots:true
  				},
  				// breakpoint from 900 up
  				900 : {
  					items:slider.items,
  					dots:true,
					stagePadding: 90
  				}
  			}
  		});
  	});
	
}


function activismAnimations(){
	$.fn.isInViewport = function() {
		var elementTop = $(this).offset().top;
		var elementBottom = elementTop + $(this).outerHeight();

		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();

		return elementBottom > viewportTop && elementTop < viewportBottom;
	};

	$(window).on('resize scroll', function() {
		
		$('.activism-page .heading h2, .activism-page .heading h5, .timeline-content, .activism-page hr').each(function() {
			if ($(this).isInViewport()) {
				$(this).addClass('animate');
			}
		});
	});
}


function fancyLinks() {
	$('.fancy-link').click(function(e){
		e.preventDefault();
		$(this).fadeOut();
		$('.'+$(this).data('link')).show();
		$('html, body').animate({
			scrollTop: $('.'+$(this).data('link')+':first').offset().top - 200
		}, 1000);
	});
	
	
	$('.design-navigation a').on('click', function(event){     
	    event.preventDefault();
	    $('html,body').animate({scrollTop:$(this.hash).offset().top}, 500);
	});
}

function checkSlide(currentSlide){
	if ($(window).width() > 500) {
		console.log('slide: '+currentSlide);
		
		if (currentSlide == 1) {
			//If first slide we show full size nav
			$('#site-header').removeClass('min');
			$('.farm-nav').fadeOut()
		} else if (currentSlide == 3) {
			$('.farm-nav').fadeOut()
			
			var timer;
			var timeout = function () {
			    //alert('No movement!');
				$('.farm-video').addClass('hide-cursor') 
			}
			timer = setTimeout(timeout, 2000);
			window.onmousemove = function() {
			    clearTimeout(timer);
				$('.farm-video').removeClass('hide-cursor')
			    timer = setTimeout(timeout, 2000);
			};
			
		} else {
			$('#site-header').addClass('min');
			$('.farm-nav').fadeIn()
		}
	}
}

function pause_play_video(playPromise, activeVideoObj, activeVideoPage){
	console.log('promsing')
	if (playPromise !== undefined) {
	    playPromise.then(_ => {
			// Automatic playback started!
			// Show playing UI.
			console.log('playing1')
			//activeVideoPage.find('.sound').hide()
			//activeVideoPage.find('.mute').show()
			activeVideoPage.find('.play').hide()
			activeVideoPage.find('.pause').show()

			
			setTimeout(function () {
				console.log('click')
				//activeVideoPage.find('.sound').trigger('click')
				//activeVideoObj.prop('muted', false);
			}, 2000);
	    })
	    .catch(error => {
			// Auto-play was prevented
			// Show paused UI.
			console.log('pausing')
	    });
	  }
}

function sleepHollowScroller(){
	
	var slider = function (sliderElement) {

		var pages = [];
		var currentSlide = 1;
		var isChanging = false;
		var keyUp = {38:1, 33:1};
		var keyDown = {40:1, 34:1};
		var scrolled = false;
		var totalSlides = 0;
  
		var init = function () {
			
			$('#site-header').addClass('transparent');
			$('body').addClass('slider__body');
			
			// control scrolling
			whatWheel = 'onwheel' in document.createElement('div') ? 'wheel' : document.onmousewheel !== undefined ? 'mousewheel' : 'DOMMouseScroll';
			window.addEventListener(whatWheel, function (e) {
				
				if(scrolled == false) {		 
					var direction = e.wheelDelta || e.deltaY;					
					if (direction > 0) {
						changeSlide(-1);
					} else {
						changeSlide(1);
					}
					scrolled = true 
					setTimeout(function(){ 
						scrolled = false 
					}, 1500);
				}
			});

			// allow keyboard input
			window.addEventListener('keydown', function (e) {
				if (keyUp[e.keyCode]) {
					changeSlide(-1);
				} else if (keyDown[e.keyCode]) {
					changeSlide(1);
				}
			});

			// page change animation is done
			detectChangeEnd() && document.querySelector(sliderElement).addEventListener(detectChangeEnd(), function () {
				
				if (isChanging) {
					setTimeout(function() {
						isChanging = false;
						window.location.hash = document.querySelector('[data-slider-index="' + currentSlide + '"]').id;
					}, 400);
				}
			});

			// set up page and build visual indicators
			document.querySelector(sliderElement).classList.add('slider__container');
			var indicatorContainer = document.createElement('div');
			indicatorContainer.classList.add('slider__indicators');

			var index = 1;
			[].forEach.call(document.querySelectorAll(sliderElement + ' > *'), function (section) {

				var indicator = document.createElement('a');
				indicator.classList.add('slider__indicator')
				indicator.setAttribute('data-slider-target-index', index);
				indicatorContainer.appendChild(indicator);

				section.classList.add('slider__page');
				pages.push(section);
				section.setAttribute('data-slider-index', index++);
			});
					
			//document.sliderElement.insertBefore(indicatorContainer);
			
			$(indicatorContainer).insertAfter(sliderElement);
			
			//document.body.appendChild(indicatorContainer);
			document.querySelector('a[data-slider-target-index = "' + currentSlide +'"]').classList.add('slider__indicator--active');
			document.querySelector('[data-slider-index="' + currentSlide +'"]').classList.add('active');
			
			//Autoplay if first slide is a video and write text
			if ($(window).width() < 480) {
				$('[data-slider-index="' + currentSlide +'"]').find('video.large--hide').trigger('play'); 
			} else {
				$('[data-slider-index="' + currentSlide +'"]').find('video.small--hide').trigger('play');
			}
			
			// stuff for touch devices
			var touchStartPos = 0;
			var touchStopPos = 0;
			var touchMinLength = 90;
	
			document.getElementById('farm-landing').addEventListener('touchstart', function(e) {
				
				if( $(e.target).is('a, a *') ) {
					window.location.href = $(e.target).attr('href');
				}
				
				e.preventDefault();
				if (e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel') {
					var touch = e.touches[0] || e.changedTouches[0];
					touchStartPos = touch.pageY;
				}
				
				
			});
			document.getElementById('farm-landing').addEventListener('touchend', function(e) {
				e.preventDefault();
				if (e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel') {
					var touch = e.touches[0] || e.changedTouches[0];
					touchStopPos = touch.pageY;
				}
	  
				if ($(".js-drawer-open")[0]){
					// If nav open dont scroll
				} else {
					if (touchStartPos + touchMinLength < touchStopPos) {
						changeSlide(-1);
					} else if (touchStartPos > touchStopPos + touchMinLength) {
						changeSlide(1);
					}
				}
			});
	
			totalSlides = $('.slider__page').length
			
			checkSlide(currentSlide)
			
		};


		// prevent double scrolling
		var detectChangeEnd = function () {
			var transition;
			var e = document.createElement('foobar');
			var transitions = {
				'transition': 'transitionend',
				'OTransition': 'oTransitionEnd',
				'MozTransition': 'transitionend',
				'WebkitTransition': 'webkitTransitionEnd'
			};

			for(transition in transitions) {
				if (e.style[transition] !== undefined) {
					return transitions[transition];
				}
			}
			return true;
		};


		// handle css change
		var changeCss = function (obj, styles) {
			for (var _style in styles) {
				if (obj.style[_style] !== undefined) {
					obj.style[_style] = styles[_style];
				}
			}
		};

		// handle page/section change
		var changeSlide = function (direction) {
			
			// already doing it or last/first page, staph plz
			if (isChanging || (direction == 1 && currentSlide == pages.length) || (direction == -1 && currentSlide == 1)) {
				return;
			}

			// change page
			currentSlide += direction;
			isChanging = true;
	
			var scroll_distance = -(currentSlide - 1) * 100;
	
			//if (currentSlide == totalSlides) {
				//if ($(window).width() > 500) {
					//If last slide we only want a half scroll
					//var scroll_distance = -(currentSlide - 1) * 100 + 35;
					//} 
			//}
			
			checkSlide(currentSlide)
			
			var target_href = document.querySelector('[data-slider-index="' + currentSlide + '"]').id
			$('.farm-nav a.active').removeClass('active')
			$('a[href$='+target_href+']').addClass('active')
			
			
			changeCss(document.querySelector(sliderElement), {
				transform: 'translate3d(0, ' + scroll_distance + '%, 0)'
			}); 
	
			// change dots
			document.querySelector('a.slider__indicator--active').classList.remove('slider__indicator--active');
			document.querySelector('a[data-slider-target-index="' + currentSlide +'"]').classList.add('slider__indicator--active');
	
			// update actie slide
			//console.log('changing');
			document.querySelector('.slider__page.active').classList.remove('active');
			document.querySelector('[data-slider-index="' + currentSlide +'"]').classList.add('active');
	
			if ($('.slider__page.active').hasClass('text-light') ) {
				$('.site-header, .slider__indicators').addClass('light');
			} else {
				$('.site-header, .slider__indicators').removeClass('light');
			}
			
			//pause all videos and then play active video and write text
			$('.section-video').find('video').trigger('pause').prop('muted', true); 
			//$('.slider__page .sound').show()
			//$('.slider__page .mute').hide()
			$('.slider__page .play').show()
			$('.slider__page .pause').hide()
			
			var activeVideoPage = $('.slider__page.active')
					
			if ($(window).width() < 480) {
				var activeVideoObj = $('.slider__page.active .section-video').find('video.large--hide')  
				var activeVideo = $('.slider__page.active .section-video').find('video.large--hide')[0]  
			} else {
				var activeVideoObj = $('.slider__page.active .section-video').find('video.small--hide')  
				var activeVideo = $('.slider__page.active .section-video').find('video.small--hide')[0]
			} 
			
			if (typeof activeVideo !== 'undefined') {
				var playPromise = activeVideo.play()
				pause_play_video(playPromise, activeVideoObj, activeVideoPage)
			}
			
			$('.slider__page.active').find('.typed-text').empty();
			$('.slider__page.active').find('.typed-text').attr('data-typer', function(i, txt) {

				var $typer = $(this),
				tot = txt.length,
				pauseMax = 100,
				pauseMin = 30,
				ch = 0;

				(function typeIt() {
					if (ch > tot) return;
					$typer.text(txt.substring(0, ch++));
					setTimeout(typeIt, ~~(Math.random() * (pauseMax - pauseMin + 1) + pauseMin));
				}());
			});
			
			
		};

		// go to spesific slide if it exists
		var gotoSlide = function (where) {
			var target = document.querySelector(where).getAttribute('data-slider-index');
			if (target != currentSlide && document.querySelector(where)) {
				changeSlide(target - currentSlide);
			}
		};

		// if page is loaded with hash, go to slide
		if (location.hash) {
			setTimeout(function () {
				window.scrollTo(0, 0);
				gotoSlide(location.hash);
			}, 1);
		};
		
		$('.farm-nav a, #site-header a').click(function(e){
			block_href = $(this).attr('href')
			
			if (block_href.indexOf('#') > -1) {
				block_href = $(this).attr('href').split('#')
				console.log('test:#'+block_href[1])
				gotoSlide('#'+block_href[1]);
			}
		});

		// we have lift off
		if (document.readyState === 'complete') {
			init();
		} else {
			window.addEventListener('onload', init(), false);
		}
  
		// navigate to pagination slide
		$('.slider__indicator').click(function(){
			gotoSlide('#'+document.querySelector('[data-slider-index="' + $(this).data('slider-target-index') + '"]').id);	  
		});

		// expose gotoSlide function
		return {
			gotoSlide: gotoSlide
		}
	};

	if ($(window).width() > screen_large) {
		var mySlider = slider('.slides');
	} else {
		$(document).on('click', '.farm-nav a[href^="#"]', function (event) {
			event.preventDefault();
			$('html, body').animate({
				scrollTop: $($.attr(this, 'href')).offset().top -100
			}, 1000);
		});
				
		$(window).on('resize scroll', function() {
			console.log('scrolling')
			$('.section-video:not(.autoplay)').each(function() {
				if ($(this).isInViewport()) {
					var activeVideoPage = $(this)
					if ($(window).width() < 480) {
						var activeVideoObj = $(this).find('video.large--hide') 
						var activeVideo = $(this).find('video.large--hide')[0] 
					} else {
						var activeVideoObj = $(this).find('video.small--hide')
						var activeVideo = $(this).find('video.small--hide')[0] 
					} 
					
					if (typeof activeVideo !== 'undefined') {
						var playPromise = activeVideo.play()
						pause_play_video(playPromise, activeVideoObj, activeVideoPage)
					}
					
					
				} else {
					$(this).find('video').prop('muted', true); 
				}
			});
		 
		});
	}
}  

function klaviyo_form_trigger(){
	$('.klaviyo_form_trigger').click(function(){	
		var K_id_trigger = $(this).data('kpopupid');
		window._klOnsite = window._klOnsite || [];
		window._klOnsite.push(['openForm', K_id_trigger]);
	});
} 

function mystery_box(){
	let mb_gender = 'mens';

	function get_random_mystery (list) {
		return list[Math.floor((Math.random()*list.length))];
	}

	function random_mystery(collection_products,mp_size) {
		let myst_prod = get_random_mystery(collection_products)
		//console.log( myst_prod )
		//console.log( mystery_product[mv_size])
	
		
	
		let found_product = false;
		if ( typeof myst_prod !== "undefined" ) {
			let mp_size_alt = 28
			if ( mp_size == 'S' ) {
				mp_size_alt = 30
			} else if ( mp_size == 'M' ) {
				mp_size_alt = 32
			} else if ( mp_size == 'L' ) {
				mp_size_alt = 34
			} else if ( mp_size == 'XL' ) {
				mp_size_alt = 36
			} 
			
			if ( mb_gender == 'womens' ) {
				mp_size_alt = 24
				if ( mp_size == 'S' ) {
					mp_size_alt = 26
				} else if ( mp_size == 'M' ) {
					mp_size_alt = 28
				} else if ( mp_size == 'L' ) {
					mp_size_alt = 30
				} else if ( mp_size == 'XL' ) {
					mp_size_alt = 32
				}
			}
			
			//alert( mp_size_alt )
						
			if ( 
				typeof myst_prod[mp_size] !== "undefined" && 
				myst_prod[mp_size].qty > 0 &&
				mb_products.indexOf(myst_prod[mp_size].id) == -1
			) {
				//Check XS - XL sizing
				mb_products.push(myst_prod[mp_size].id);
				found_product = true;
			} else if ( 
				typeof myst_prod[mp_size_alt] !== "undefined" && 
				myst_prod[mp_size_alt].qty > 0 &&
				mb_products.indexOf(myst_prod[mp_size_alt].id) == -1
			) {
				// Check for numerical sizing
				mb_products.push(myst_prod[mp_size_alt].id);
				found_product = true;
			} else {
				//If random unavailable lets jsut grab first available
				collection_products.forEach(function(myst_prod){
				
					//alert(mb_products.indexOf(myst_prod[mp_size].id) + ' : ' + mb_products + ' : ' + myst_prod[mp_size].id);
				
					if ( 
						found_product == false && 
						typeof  myst_prod[mp_size] !== "undefined" && 
						myst_prod[mp_size].qty > 0 &&
						mb_products.indexOf(myst_prod[mp_size].id) == -1
					) {
						//Check XS - XL sizing
 						mb_products.push(myst_prod[mp_size].id);
						found_product = true;
					} else if ( 
						found_product == false && 
						typeof myst_prod[mp_size_alt] !== "undefined" && 
						myst_prod[mp_size_alt].qty > 0 &&
						mb_products.indexOf(myst_prod[mp_size_alt].id) == -1
					) {
						// Check for numerical sizing
						mb_products.push(myst_prod[mp_size_alt].id);
						found_product = true;
					}
				});	
			}
		}
	
		if ( found_product ) {
			//alert("Found: "+mp_size)
			mystery_box.moveAlong();
		} else {
			console.log("Error: Couldn't find any products in the selected sizes")
			alert("Error: Couldn't find any products in the selected sizes") ? "" : location.reload();
		}
		//console.log('available?' + mystery_product_available)
	}

	const mb_random = parseInt(Math.random() * 2)

	function search_mystery_collection(mystery_type) {
		//console.log( mv.title )	
		const mt_handle = mystery_type.title.replace(/ /g,'-');

		//XS-28 S-30 M-32 L-34 XL-36
		const
			tops_products = 'short sleeve tops,long sleeve tops,hoodies',
			bottoms_products = 'shorts,pants';
		let 
			mp_size = 'OS',
			mt_handle_spaced = mt_handle.replace(/-/g, ' ');
		
		//alert( tops_products.indexOf(mt_handle) )
			
		if ( tops_products.indexOf(mt_handle_spaced) !== -1 ) {
			mp_size = $('#mb-tops-swatches input:checked').val();
		} else if ( bottoms_products.indexOf(mt_handle_spaced) !== -1 ) {
			mp_size = $('#mb-bottoms-swatches input:checked').val();
		}
		
		/*
		if ( mt_handle == 'short-sleeve-tops' || mt_handle == 'short sleeve tops' || mt_handle == 'long-sleeve-tops' ) {
			mp_size = $('#mb-tops-swatches input:checked').val();
		} else if ( mt_handle == 'shorts' || mt_handle == 'pants' ) {
			mp_size = $('#mb-bottoms-swatches input:checked').val();
		}*/
	
		/* OS does have gender preference
		if ( mp_size == 'OS' ) {
		mb_gender = ''
		}
		*/
	
		//Womens type conversions
		if ( mt_handle == 'shorts' && mb_gender == 'womens' && mb_random == 0 ) {
			mt_handle == 'skirts'
		}
	
		if ( mb_random == 0 ) {
			if ( mt_handle == 'pants' ) {
				mt_handle == 'jeans'
			}
		}
	
		console.log( mp_size )
	
		const collection_url = '/collections/mystery/'+mb_gender+'+type:'+mt_handle+'?view=json_mystery';
		//alert( collection_url )
		console.log( collection_url );
	
		$.ajax({
			url: collection_url,
			type: 'GET' 
		}) 
		.done(function(data) {
			//console.log( collection_url )
			//console.log($.parseJSON(data));
			let collection_products = $.parseJSON(data)
		
			//Remove unavailable products
			collection_products = collection_products.results.filter(element => {
				if (Object.keys(element).length !== 0) {
					return true;
				}
				return false;
			});
		
			//console.log(collection_products)
			random_mystery(collection_products,mp_size);		
		});
	} 

	//Loop over MP variants
	mystery_box.moveAlong = function() {
		if (json_product.variants.length) {
			var mystery_type = json_product.variants.shift();
			//console.log(mystery_type)
			search_mystery_collection(mystery_type)
		} else {
			$('#add-mystery-box').text('Adding Box To Cart');
		
			//alert('completed');
			//alert( mb_products );
		
			Shopify.moveAlong = function() {
				if (mb_products.length) {
					var mb_variant_id = mb_products.shift(); 
			
					product_data = {
						quantity: 1, 
						id: mb_variant_id,
						properties: {
							'Mystery Box': mystery_box_title
						}
					} 
			
					$.ajax({
						type: 'POST',
						url: '/cart/add.js',
						dataType: 'json',
						data: product_data,
						success: function(res){
							Shopify.moveAlong();
						},
						error: function(error){
							console.log(error);
							console.log("error: " + request);
							Shopify.moveAlong()
						}
					});
				} else {
					$('#add-mystery-box').text('Added To Cart');
					build_cart();
				}			
			};
			Shopify.moveAlong();
		}
	}

	if (json_product !== null && json_product.type == 'Mystery Box') {
		if ( json_product.title.indexOf('WOMENS') !== -1 ) {
			mb_gender = 'womens'
		}

		//console.log( mb_gender )
		
		$('#add-mystery-box').click(function() {
			$('#add-mystery-box').text('Randomising products').prop('disabled', true);
			mb_gender = $('#mb-gender-swatches input:checked').val();
			mystery_box.moveAlong();	
		});		
	}
}  

function remove_mystery_box(button){
	button.text('removing box');  
	line_keys = button.attr("data-keys").split(',');

	Shopify.moveAlong = function() {
		if (line_keys.length) {
			var line_key = line_keys.shift(); 
	
			product_data = {
				id: line_key,
				quantity:0 
			} 
	
			$.ajax({
				type: 'POST',
				url: '/cart/change.js',
				dataType: 'json',
				data: product_data,
				success: function(res){
					Shopify.moveAlong();
				},
				error: function(error){
					console.log(error);
					console.log("error: " + request);
					Shopify.moveAlong()
				}
			});
		} else {
			if ( window.location.pathname.indexOf('f-k-yeah-box') !== -1 ) {
				setTimeout(function() {
					location.reload();
				}, 2000);
			}
			else if ( window.location.pathname == '/cart' ) {
				location.reload();
			} else { 
				//ajaxCart.load();
				build_cart();
			}
		}			
	};
	Shopify.moveAlong();
}

$('#cart-drawer').on('click', '.remove-mystery-box', function() {
	remove_mystery_box($(this))
});

$('.remove-mystery-box').click(function(e){	
	remove_mystery_box($(this))
});

 
$(document).ready(function() {
	
	new MobileMenu();
	new headerCountdown();
	new ScrollNav();
	new lazyloadVideos();
	
    new Popup(); 
	
	setTimeout(playVideos, 1000);
	
    new QuickView();
    new CollectionLandingNav();	
    SecondImageRollovers.initRollovers();
		
	if (window.location.href.indexOf('/products/') != -1) {
		
		new Tab(); 
	  	new variant_reorder(); 
	  	new checkSwatches();
	  	new sizeGuide();
		new ProductVideoThumbs();
		new productSlideshow();
		new ProductFunctions();
		new ProductColorSwatches();
		//new ProductPickup();
		new mystery_box();
	}
	
	new ProductOutOfStock();
	
  	new homepageAnimations();
	new sectionHighlights();
		
	new eventTracking();
	new accordions(); 
	
	new activismAnimations(); 
	new loadBackgroundImages();
	new fancyLinks();
	new klaviyoRadios(); 

	new fundraising();
	
	if (typeof CollectionSliders != 'undefined') {
		new collectionSlider();
	} 
	
	if (typeof ContentCarousel != 'undefined') {
		new contentCarousel();
	} 
	
	if (window.location.href.indexOf('/pages/sleepy-hollow') != -1) {
		new sleepHollowScroller();
	}
	
	new klaviyo_form_trigger();
	
	//Theme editor refresh functions
	document.addEventListener("shopify:section:load", function(event) {
		new playVideos();
	});
  	//new searchFunctions();

});